import styled from '@emotion/styled';
import React from 'react';

var StyledSvg = styled.svg({
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: '24px',
    userSelect: 'none',
    outline: 'none',
    flexShrink: 0,
    flexGrow: 0,
});

var _path;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.632 10.579 21.8 21h-2.042l-1.137-2.842h-3.875L13.61 21h-2.04l4.167-10.421h1.895ZM9.579 3v1.895h5.684v1.894H13.4c-.731 2.2-1.897 4.23-3.43 5.97.684.61 1.425 1.151 2.213 1.617l-.711 1.78a16.122 16.122 0 0 1-2.84-2.048 15.798 15.798 0 0 1-5.874 3.361l-.508-1.827a13.928 13.928 0 0 0 5.047-2.882A17.127 17.127 0 0 1 4.62 8.684h2.122a15.188 15.188 0 0 0 1.889 2.726 15.315 15.315 0 0 0 2.756-4.62H2V4.894h5.684V3H9.58Zm7.105 10.312-1.181 2.951h2.36l-1.179-2.95Z",
    fill: "currentColor"
  })));
};

var SvgAppLocalization = function SvgAppLocalization(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread({
    as: SvgComponent
  }, props));
};

var _path$1;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgComponent$1 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 4.25a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-3.5ZM5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm.25 11.25a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-3.5ZM5 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5Zm9.25-7.75a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-3.5ZM13 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5Zm2.25 9.25a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-3.5ZM15 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4Z",
    clipRule: "evenodd"
  })));
};

var SvgAppsThin = function SvgAppsThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1({
    as: SvgComponent$1
  }, props));
};

var _path$2;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgComponent$2 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V3.9a.9.9 0 0 1 .9-.9h11.7a.9.9 0 0 1 .9.9v11.7a.9.9 0 0 1-.9.9h-3.6v3.594c0 .5-.404.906-.906.906H3.906A.906.906 0 0 1 3 20.094l.003-11.688c0-.5.404-.906.906-.906H7.5Zm1.8 0h6.294c.5 0 .906.404.906.906V14.7h2.7V4.8H9.3v2.7Zm5.4 1.8H4.803L4.8 19.2h9.9V9.3Zm-5.847 8.1L5.67 14.218l1.273-1.273 1.91 1.91 3.818-3.819 1.272 1.273-5.09 5.091Z",
    fill: "currentColor"
  })));
};

var SvgAppStages = function SvgAppStages(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2({
    as: SvgComponent$2
  }, props));
};

var _path$3;

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgComponent$3 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6z",
    fill: "currentColor"
  })));
};

var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$3({
    as: SvgComponent$3
  }, props));
};

var _path$4;

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgComponent$4 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C5.85775 17.5 2.5 14.1422 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5C14.1422 2.5 17.5 5.85775 17.5 10C17.5 14.1422 14.1422 17.5 10 17.5ZM9.25 9.25H6.25V10.75H9.25V13.75H10.75V10.75H13.75V9.25H10.75V6.25H9.25V9.25Z",
    fill: "#5E6993"
  })));
};

var SvgAddCircleFill = function SvgAddCircleFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$4({
    as: SvgComponent$4
  }, props));
};

var _path$5;

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgComponent$5 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5V17.5H4C4 15.9087 4.63214 14.3826 5.75736 13.2574C6.88258 12.1321 8.4087 11.5 10 11.5ZM10 10.75C7.51375 10.75 5.5 8.73625 5.5 6.25C5.5 3.76375 7.51375 1.75 10 1.75C12.4862 1.75 14.5 3.76375 14.5 6.25C14.5 8.73625 12.4862 10.75 10 10.75ZM16.75 13.75H17.5V17.5H11.5V13.75H12.25V13C12.25 12.4033 12.4871 11.831 12.909 11.409C13.331 10.9871 13.9033 10.75 14.5 10.75C15.0967 10.75 15.669 10.9871 16.091 11.409C16.5129 11.831 16.75 12.4033 16.75 13V13.75ZM15.25 13.75V13C15.25 12.8011 15.171 12.6103 15.0303 12.4697C14.8897 12.329 14.6989 12.25 14.5 12.25C14.3011 12.25 14.1103 12.329 13.9697 12.4697C13.829 12.6103 13.75 12.8011 13.75 13V13.75H15.25Z",
    fill: "#5E6993"
  })));
};

var SvgAdminFill = function SvgAdminFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$5({
    as: SvgComponent$5
  }, props));
};

var _path$6;

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgComponent$6 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.252v2.09A6 6 0 005 22l-2-.001a8 8 0 0110-7.748v.001zM11 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
  })));
};

var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$6({
    as: SvgComponent$6
  }, props));
};

var _path$7;

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgComponent$7 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.586 4.414c0-.89-1.077-1.337-1.707-.707l-7.586 7.586a1 1 0 000 1.414l7.586 7.586c.63.63 1.707.184 1.707-.707V16H20a1 1 0 001-1V9a1 1 0 00-1-1h-7.414V4.414zM11.1 9.5V5.594l-6.047 6.053a.5.5 0 000 .706l6.047 6.053V14.5H19a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7.9z",
    clipRule: "evenodd"
  })));
};

var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$7({
    as: SvgComponent$7
  }, props));
};

var _path$8;

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgComponent$8 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.172 11-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2h12.172Z"
  })));
};

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$8({
    as: SvgComponent$8
  }, props));
};

var _path$9;

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgComponent$9 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "m7.828 10.778 5.364-5.364L11.778 4 4 11.778l7.778 7.778 1.414-1.414-5.364-5.364H20v-2H7.828Z"
  })));
};

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$9({
    as: SvgComponent$9
  }, props));
};

var _path$a;

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var SvgComponent$a = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M16.021 9.414l-8.607 8.607L6 16.607 14.606 8H7.021V6h11v11h-2V9.414z"
  })));
};

var SvgArrowRightUp = function SvgArrowRightUp(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$a({
    as: SvgComponent$a
  }, props));
};

var _path$b;

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var SvgComponent$b = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.9 5.7c-.15 0-.31-.06-.42-.18L10.5 3.548V14.9c0 .33-.27.6-.6.6-.33 0-.6-.27-.6-.6V3.548L7.32 5.52a.61.61 0 01-.85 0 .61.61 0 010-.85l3-3a.61.61 0 01.85 0l3 3c.23.23.23.61 0 .85-.11.12-.27.18-.42.18zm1.2 16.8a.597.597 0 00.211-.039.69.69 0 00.23-.14l3-3a.61.61 0 000-.85.61.61 0 00-.85 0L14.7 20.46V9.1c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v11.34l-1.97-1.97a.61.61 0 00-.85 0 .61.61 0 000 .85l2.944 2.944a.6.6 0 00.476.236z",
    clipRule: "evenodd"
  })));
};

var SvgArrowUpDown = function SvgArrowUpDown(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$b({
    as: SvgComponent$b
  }, props));
};

var _path$c;

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var SvgComponent$c = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    viewBox: "0 -3 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H1C0.447812 0 0 0.447812 0 1V13C0 13.5522 0.447812 14 1 14H19C19.5522 14 20 13.5522 20 13V1C20 0.447812 19.5522 0 19 0ZM5.5 9.24625V9.75C5.5 9.88813 5.38812 10 5.25 10H4.75C4.61188 10 4.5 9.88813 4.5 9.75V9.24094C4.14719 9.22281 3.80406 9.09969 3.51969 8.88625C3.39781 8.79469 3.39156 8.61219 3.50187 8.50688L3.86906 8.15656C3.95562 8.07406 4.08437 8.07031 4.18563 8.13375C4.30656 8.20938 4.44375 8.25 4.58625 8.25H5.46469C5.66781 8.25 5.83344 8.065 5.83344 7.83781C5.83344 7.65188 5.72062 7.48812 5.55937 7.44L4.15312 7.01812C3.57219 6.84375 3.16625 6.28625 3.16625 5.66219C3.16625 4.89594 3.76156 4.27344 4.49969 4.25375V3.75C4.49969 3.61188 4.61156 3.5 4.74969 3.5H5.24969C5.38781 3.5 5.49969 3.61188 5.49969 3.75V4.25906C5.8525 4.27719 6.19562 4.4 6.48 4.61375C6.60187 4.70531 6.60812 4.88781 6.49781 4.99312L6.13062 5.34344C6.04406 5.42594 5.91531 5.42969 5.81406 5.36625C5.69313 5.29031 5.55594 5.25 5.41344 5.25H4.535C4.33187 5.25 4.16625 5.435 4.16625 5.66219C4.16625 5.84812 4.27906 6.01188 4.44031 6.06L5.84656 6.48187C6.4275 6.65625 6.83344 7.21375 6.83344 7.83781C6.83344 8.60437 6.23812 9.22656 5.5 9.24625ZM13 8.75C13 8.88813 12.8881 9 12.75 9H9.25C9.11187 9 9 8.88813 9 8.75V8.25C9 8.11187 9.11187 8 9.25 8H12.75C12.8881 8 13 8.11187 13 8.25V8.75ZM18 8.75C18 8.88813 17.8881 9 17.75 9H15.25C15.1119 9 15 8.88813 15 8.75V8.25C15 8.11187 15.1119 8 15.25 8H17.75C17.8881 8 18 8.11187 18 8.25V8.75ZM18 5.75C18 5.88812 17.8881 6 17.75 6H9.25C9.11187 6 9 5.88812 9 5.75V5.25C9 5.11188 9.11187 5 9.25 5H17.75C17.8881 5 18 5.11188 18 5.25V5.75Z"
  })));
};

var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$c({
    as: SvgComponent$c
  }, props));
};

var _path$d;

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgComponent$d = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M5.763 16H20V4H4v13.385L5.763 16zm.692 2L2 21.5V3a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H6.455z"
  })));
};

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$d({
    as: SvgComponent$d
  }, props));
};

var _path$e;

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgComponent$e = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M13 4v2H3v13.385L4.763 18H19v-7h2v8a1 1 0 01-1 1H5.455L1 23.5V5a1 1 0 011-1h11zm5 0V1h2v3h3v2h-3v3h-2V6h-3V4h3z"
  })));
};

var SvgChatNew = function SvgChatNew(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$e({
    as: SvgComponent$e
  }, props));
};

var _path$f;

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgComponent$f = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.25H16.75C16.9489 3.25 17.1397 3.32902 17.2803 3.46967C17.421 3.61032 17.5 3.80109 17.5 4V16C17.5 16.1989 17.421 16.3897 17.2803 16.5303C17.1397 16.671 16.9489 16.75 16.75 16.75H3.25C3.05109 16.75 2.86032 16.671 2.71967 16.5303C2.57902 16.3897 2.5 16.1989 2.5 16V4C2.5 3.80109 2.57902 3.61032 2.71967 3.46967C2.86032 3.32902 3.05109 3.25 3.25 3.25ZM13.348 12.652L16 10L13.348 7.348L12.2875 8.41L13.879 10L12.2875 11.5907L13.348 12.652ZM6.121 10L7.7125 8.40925L6.652 7.348L4 10L6.652 12.652L7.7125 11.59L6.121 10ZM9.433 13.75L12.163 6.25H10.567L7.837 13.75H9.433Z",
    fill: "#5E6993"
  })));
};

var SvgCodeBoxFill = function SvgCodeBoxFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$f({
    as: SvgComponent$f
  }, props));
};

var _path$g;

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$g(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgComponent$g = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M18.193 15.364l-1.414-1.416 1.414-1.414a5 5 0 10-7.07-7.07L9.707 6.877 8.293 5.464 9.71 4.05a7 7 0 119.9 9.9l-1.415 1.414zm-2.828 2.828l-1.415 1.414a7 7 0 01-9.9-9.9l1.415-1.414L6.88 9.708l-1.414 1.414a5 5 0 107.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607L16.072 9l-7.07 7.07-1.416-1.414 7.071-7.07z"
  })));
};

var SvgSlug = function SvgSlug(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$g({
    as: SvgComponent$g
  }, props));
};

var _path$h;

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$h(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgComponent$h = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M3.001 12.998h2.015a7.002 7.002 0 0013.858 0h2.016a9.001 9.001 0 01-17.89 0h.001zm0-2a9.001 9.001 0 0117.89 0h-2.015a7.002 7.002 0 00-13.858 0H3.001z"
  })));
};

var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$h({
    as: SvgComponent$h
  }, props));
};

var _path$i;

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty$i(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgComponent$i = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M13.5677 3.24995L7.96825 8.84945L7.97425 12.0347L11.1528 12.0295L16.75 6.4322V15.9999C16.75 16.1989 16.671 16.3896 16.5303 16.5303C16.3897 16.6709 16.1989 16.7499 16 16.7499H4C3.80109 16.7499 3.61032 16.6709 3.46967 16.5303C3.32902 16.3896 3.25 16.1989 3.25 15.9999V3.99995C3.25 3.80104 3.32902 3.61027 3.46967 3.46962C3.61032 3.32897 3.80109 3.24995 4 3.24995H13.5677ZM16.3638 2.57495L17.425 3.63695L10.531 10.531L9.472 10.5332L9.4705 9.47045L16.3638 2.57495Z",
    fill: "#5E6993"
  })));
};

var SvgEditBoxFill = function SvgEditBoxFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$i({
    as: SvgComponent$i
  }, props));
};

var _path$j;

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty$j(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgComponent$j = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.5V3.25C6.25 3.05109 6.32902 2.86032 6.46967 2.71967C6.61032 2.57902 6.80109 2.5 7 2.5H16C16.1989 2.5 16.3897 2.57902 16.5303 2.71967C16.671 2.86032 16.75 3.05109 16.75 3.25V13.75C16.75 13.9489 16.671 14.1397 16.5303 14.2803C16.3897 14.421 16.1989 14.5 16 14.5H13.75V16.75C13.75 17.164 13.4125 17.5 12.9948 17.5H4.00525C3.90635 17.5006 3.8083 17.4816 3.71674 17.4442C3.62519 17.4068 3.54192 17.3517 3.47174 17.282C3.40156 17.2123 3.34584 17.1294 3.30779 17.0381C3.26974 16.9468 3.2501 16.8489 3.25 16.75L3.25225 6.25C3.25225 5.836 3.58975 5.5 4.0075 5.5H6.25ZM7.75 5.5H13.75V13H15.25V4H7.75V5.5ZM6.25 9.25V10.75H10.75V9.25H6.25ZM6.25 12.25V13.75H10.75V12.25H6.25Z",
    fill: "#495173"
  })));
};

var SvgFileCopyFill = function SvgFileCopyFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$j({
    as: SvgComponent$j
  }, props));
};

var _circle, _path$k;

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty$k(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgComponent$k = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#6246EA",
    stroke: "#6246EA"
  })), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.334v-.667a4 4 0 118 0v.667h1.333A.667.667 0 0122 14v8a.666.666 0 01-.667.667H10.667A.666.666 0 0110 22v-8a.666.666 0 01.667-.666H12zm8.667 1.333h-9.334v6.667h9.334v-6.667zm-5.334 3.821a1.333 1.333 0 111.334 0V20h-1.334v-1.512zm-2-5.154h5.334v-.667a2.667 2.667 0 00-5.334 0v.667z",
    fill: "#fff"
  })));
};

var SvgStatusDisabled = function SvgStatusDisabled(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$k({
    as: SvgComponent$k
  }, props));
};

var _circle$1, _circle2;

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty$l(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var SvgComponent$l = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#fff",
    stroke: "#6246EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    transform: "matrix(-1 0 0 1 16 16)",
    fill: "#6246EA"
  })));
};

var SvgStatusActive = function SvgStatusActive(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$l({
    as: SvgComponent$l
  }, props));
};

var _circle$2, _path$l;

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty$m(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var SvgComponent$m = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#6246EA",
    stroke: "#6246EA"
  })), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M14.364 19.193L23.556 10l1.415 1.414-10.607 10.607L8 15.657l1.414-1.414 4.95 4.95z",
    fill: "#fff"
  })));
};

var SvgStatusCompleted = function SvgStatusCompleted(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$m({
    as: SvgComponent$m
  }, props));
};

var _circle$3;

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty$n(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var SvgComponent$n = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#fff",
    stroke: "#DADEED"
  })));
};

var SvgStatusInitial = function SvgStatusInitial(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$n({
    as: SvgComponent$n
  }, props));
};

var _path$m;

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty$o(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var SvgComponent$o = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12a1 1 0 10-2 0 1 1 0 002 0zm1.83-1a3.001 3.001 0 100 2h8.34a3.001 3.001 0 100-2H7.83zM20 12a1 1 0 10-2 0 1 1 0 002 0z"
  })));
};

var SvgOneToOne = function SvgOneToOne(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$o({
    as: SvgComponent$o
  }, props));
};

var _path$n;

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty$p(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var SvgComponent$p = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12a1 1 0 10-2 0 1 1 0 002 0zM5 9c.654 0 1.26.21 1.753.565l9.367-5.408a3.001 3.001 0 11.2 2.194L8.269 11h7.903a3.001 3.001 0 110 2H8.268l8.053 4.65a3 3 0 11-.201 2.193l-9.367-5.408A3 3 0 115 9zm15 3a1 1 0 10-2 0 1 1 0 002 0zm-1-8a1 1 0 110 2 1 1 0 010-2zm1 15a1 1 0 10-2 0 1 1 0 002 0z"
  })));
};

var SvgOneToMany = function SvgOneToMany(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$p({
    as: SvgComponent$p
  }, props));
};

var _path$o;

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty$q(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var SvgComponent$q = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12a1 1 0 112 0 1 1 0 01-2 0zm1-3c-.654 0-1.26.21-1.753.565L7.88 4.157A3.001 3.001 0 002 5a3 3 0 005.68 1.35L15.731 11H7.829a3.001 3.001 0 100 2h7.903L7.68 17.65a3 3 0 10.201 2.193l9.367-5.408A3 3 0 1019 9zM4 12a1 1 0 112 0 1 1 0 01-2 0zm1-8a1 1 0 100 2 1 1 0 000-2zM4 19a1 1 0 112 0 1 1 0 01-2 0z"
  })));
};

var SvgManyToOne = function SvgManyToOne(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$q({
    as: SvgComponent$q
  }, props));
};

var _path$p;

function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty$r(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var SvgComponent$r = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11a1 1 0 110 2 1 1 0 010-2zm1.753-1.435a3 3 0 100 4.87L10 16.309l-2.32 1.34a3 3 0 10.2 2.194L12 17.464l4.12 2.379A3.001 3.001 0 0022 19a3 3 0 00-5.68-1.35L14 16.31l3.247-1.875.003.002a3 3 0 10-.003-4.872L14 7.691l2.32-1.34a3 3 0 10-.2-2.194L12 6.536 7.88 4.157A3.001 3.001 0 002 5a3 3 0 005.68 1.35L10 7.69 6.753 9.566zM8.268 11h7.464L12 8.845 8.268 11zm7.464 2H8.268L12 15.155 15.732 13zM19 11a1 1 0 110 2 1 1 0 010-2zm1-6a1 1 0 10-2 0 1 1 0 002 0zm-1 13a1 1 0 110 2 1 1 0 010-2zM4 5a1 1 0 112 0 1 1 0 01-2 0zm1 13a1 1 0 100 2 1 1 0 000-2z"
  })));
};

var SvgManyToMany = function SvgManyToMany(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$r({
    as: SvgComponent$r
  }, props));
};

var _path$q;

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty$s(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var SvgComponent$s = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z",
    fill: "currentColor"
  })));
};

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$s({
    as: SvgComponent$s
  }, props));
};

var _path$r;

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$t(Object(source), !0).forEach(function (key) { _defineProperty$t(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var SvgComponent$t = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "M10.364 15.193L19.556 6l1.415 1.414-10.607 10.607L4 11.657l1.414-1.414 4.95 4.95z"
  })));
};

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$t({
    as: SvgComponent$t
  }, props));
};

var _g;

function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$u(Object(source), !0).forEach(function (key) { _defineProperty$u(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var SvgComponent$u = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    viewBox: "0 0.5 9 13",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5,
    r: 1.5
  }))));
};

var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$u({
    as: SvgComponent$u
  }, props));
};

var _path$s;

function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$v(Object(source), !0).forEach(function (key) { _defineProperty$v(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var SvgComponent$v = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"
  })));
};

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$v({
    as: SvgComponent$v
  }, props));
};

var _path$t;

function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$w(Object(source), !0).forEach(function (key) { _defineProperty$w(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var SvgComponent$w = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-5V4H5v7.857l1.5 1.393L10 9.5l3 5 2-2.5 3 3-3-.5-2 2.5-3-4-3 3.5-2-1.25V20h14V9Zm2-1v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Z"
  })));
};

var SvgError404 = function SvgError404(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$w({
    as: SvgComponent$w
  }, props));
};

var _path$u;

function ownKeys$x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$x(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$x(Object(source), !0).forEach(function (key) { _defineProperty$x(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var SvgComponent$x = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    viewBox: "-1 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.1 2.7l5 2.9c.2-.2.3-.3.5-.4 1.1-.6 2.4-.2 3 .8.6 1 .3 2.3-.8 2.9-.2.1-.4.2-.6.2v5.7l.6.3c1.1.6 1.4 1.9.8 2.9-.6 1-1.9 1.3-3 .8-.2-.2-.4-.3-.5-.5L13 21.2c.1.2.2.4.2.6 0 1.2-1 2.2-2.2 2.2-1.3 0-2.2-1-2.2-2.2 0-.2 0-.4.1-.6l-5.1-2.8c-.2.1-.3.3-.5.4-1.1.5-2.4.2-3-.8-.6-1-.2-2.3.8-2.9l.6-.3V9.1c-.2 0-.4-.1-.6-.2C0 8.3-.3 7 .3 6c.6-1 1.9-1.4 3-.8.2.1.3.2.5.4l5.1-2.9c-.1-.2-.1-.4-.1-.6C8.8 1 9.7 0 11 0c1.2 0 2.2 1 2.2 2.1 0 .2-.1.5-.1.6zm-.6.9l5.1 2.9c-.2.5-.1 1.1.2 1.6.3.6.8.9 1.4 1v5.7s-.1 0-.1.1L12.5 3.7v-.1zm-3.1.1L2.8 14.9c0-.1 0-.1-.1-.1V9.1c.6-.1 1.1-.4 1.4-1 .3-.5.4-1.1.2-1.6l5.1-2.9v.1zm2.2.5l6.6 11.2c-.2.1-.3.3-.4.4-.1.2-.2.4-.2.6H4.3c0-.2-.1-.4-.2-.6-.1-.1-.2-.3-.4-.4l6.6-11.2c.2 0 .5.1.7.1.2 0 .4-.1.6-.1zm1 16.2l5-2.8v-.2H4.3v.1l5.1 2.9c.4-.5 1-.7 1.6-.7.6 0 1.2.2 1.6.7z"
  })));
};

var SvgGraphql = function SvgGraphql(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$x({
    as: SvgComponent$x
  }, props));
};

var _path$v;

function ownKeys$y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$y(Object(source), !0).forEach(function (key) { _defineProperty$y(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var SvgComponent$y = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18v-3.7a1.5 1.5 0 0 0-1.5-1.5H1v-1.6h.5A1.5 1.5 0 0 0 3 9.7V6a3 3 0 0 1 3-3h1v2H6a1 1 0 0 0-1 1v4.1A2 2 0 0 1 3.626 12 2 2 0 0 1 5 13.9V18a1 1 0 0 0 1 1h1v2H6a3 3 0 0 1-3-3Zm5.56-1.633h1.845v-3.094h1.347l1.653 3.094h2.037l-1.854-3.392c.993-.426 1.543-1.291 1.543-2.484 0-1.735-1.146-2.851-3.128-2.851H8.56v8.727Zm1.845-4.577V9.149h1.245c1.065 0 1.58.473 1.58 1.343 0 .865-.515 1.3-1.572 1.3h-1.253ZM21 14.3V18a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-4.1a2 2 0 0 1 1.374-1.9A2 2 0 0 1 19 10.1V6a1 1 0 0 0-1-1h-1V3h1a3 3 0 0 1 3 3v3.7a1.5 1.5 0 0 0 1.5 1.5h.5v1.6h-.5a1.5 1.5 0 0 0-1.5 1.5Z"
  })));
};

var SvgRest = function SvgRest(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$y({
    as: SvgComponent$y
  }, props));
};

var _g$1, _defs;

function ownKeys$z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$z(Object(source), !0).forEach(function (key) { _defineProperty$z(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var SvgComponent$z = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.899V11.9a7.001 7.001 0 01-7 7H8A7 7 0 018 4.899V6.9a5 5 0 100 10h.501a5 5 0 005-5v-2h2V9.9zm.5 9V16.9a5.002 5.002 0 005.023-5A5 5 0 0016 6.9h-.5a5 5 0 00-5 5v2h-2v-2a7 7 0 017-7h.5a7 7 0 110 14.001V18.9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};

var SvgReference = function SvgReference(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$z({
    as: SvgComponent$z
  }, props));
};

var _path$w;

function ownKeys$A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$A(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$A(Object(source), !0).forEach(function (key) { _defineProperty$A(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$A(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var SvgComponent$A = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.501 1l-1.4 1.4 3.422 3.424A6.998 6.998 0 001 11.899a7 7 0 007 7l.5.002a7.001 7.001 0 005.887-3.213l1.614 1.613V18.9a7 7 0 001.448-.151L20.7 22l1.401-1.4L2.5 1h.001zM21.05 16.75A7 7 0 0016 4.9h-.5a7 7 0 00-4.587 1.712l1.42 1.42A5 5 0 0115.5 6.9h.5a5 5 0 013.646 8.446l1.404 1.404zM15.5 11.2V9.9h-1.3l1.3 1.3zM4.45 8.357a5 5 0 011.555-1.051L8.75 10.05A7 7 0 008.5 11.9v2h2v-2l.002-.098 2.424 2.424A5 5 0 018.501 16.9h-.5a5.003 5.003 0 01-5.023-5 5 5 0 011.473-3.543z"
  })));
};

var SvgUnreference = function SvgUnreference(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$A({
    as: SvgComponent$A
  }, props));
};

var _path$x;

function ownKeys$B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$B(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$B(Object(source), !0).forEach(function (key) { _defineProperty$B(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$B(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var SvgComponent$B = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    d: "M18.364 5.636 16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364Z"
  })));
};

var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$B({
    as: SvgComponent$B
  }, props));
};

var _path$y;

function ownKeys$C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$C(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$C(Object(source), !0).forEach(function (key) { _defineProperty$C(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$C(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var SvgComponent$C = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
  })));
};

var SvgLocale = function SvgLocale(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$C({
    as: SvgComponent$C
  }, props));
};

var _path$z, _path2;

function ownKeys$D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$D(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$D(Object(source), !0).forEach(function (key) { _defineProperty$D(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$D(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var SvgComponent$D = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"
  })));
};

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$D({
    as: SvgComponent$D
  }, props));
};

var _path$A;

function ownKeys$E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$E(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$E(Object(source), !0).forEach(function (key) { _defineProperty$E(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$E(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var SvgComponent$E = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.689V17.5H4C3.99977 16.5842 4.20919 15.6804 4.61222 14.858C5.01526 14.0357 5.6012 13.3164 6.32516 12.7555C7.04912 12.1946 7.89188 11.8068 8.78887 11.622C9.68585 11.4371 10.6132 11.46 11.5 11.689ZM10 10.75C7.51375 10.75 5.5 8.73625 5.5 6.25C5.5 3.76375 7.51375 1.75 10 1.75C12.4862 1.75 14.5 3.76375 14.5 6.25C14.5 8.73625 12.4862 10.75 10 10.75ZM15.5635 13.75H18.253V15.25H15.5635L16.9352 16.621L15.8748 17.6822L12.6925 14.5L15.8748 11.3177L16.9352 12.379L15.5635 13.75Z",
    fill: "#5E6993"
  })));
};

var SvgUserReceivedFill = function SvgUserReceivedFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$E({
    as: SvgComponent$E
  }, props));
};

var _path$B;

function ownKeys$F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$F(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$F(Object(source), !0).forEach(function (key) { _defineProperty$F(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$F(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var SvgComponent$F = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M11.137 6.494a.999.999 0 0 1 1.737.012l2.652 4.74a4.996 4.996 0 0 1 3.976 9.096 4.99 4.99 0 0 1-4.74.137l-.202-.106.977-1.743a2.996 2.996 0 1 0 .125-5.29l-.155.083-.017-.03-.802.45-3.558-6.362a.998.998 0 0 1 .007-.987Zm-7.434 5.729 1.317 1.502a2.996 2.996 0 1 0 4.963 2.481l.008-.18h.016v-1.042h6.989a.999.999 0 1 1 0 1.998h-5.108a4.996 4.996 0 0 1-9.717.29 4.993 4.993 0 0 1 1.365-4.896l.167-.153ZM12.003 2a4.994 4.994 0 0 1 4.988 4.777l.005.217h-1.997a2.996 2.996 0 1 0-4.615 2.522l.086.052.957.533-3.546 6.367H7.88l-.007.014a.999.999 0 0 1-1.26.418l-.104-.052a.999.999 0 0 1-.365-1.365l-.008.014 2.62-4.708A4.994 4.994 0 0 1 12.002 2Z"
  })));
};

var SvgWebhook = function SvgWebhook(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$F({
    as: SvgComponent$F
  }, props));
};

var _path$C;

function ownKeys$G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$G(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$G(Object(source), !0).forEach(function (key) { _defineProperty$G(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$G(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var SvgComponent$G = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M7.002 20.983a6.5 6.5 0 01-2.936-12 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12v.02h-10v-.02zm6-7.98h3l-4-5-4 5h3v4h2v-4z"
  })));
};

var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$G({
    as: SvgComponent$G
  }, props));
};

var _path$D;

function ownKeys$H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$H(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$H(Object(source), !0).forEach(function (key) { _defineProperty$H(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$H(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var SvgComponent$H = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    viewBox: "0 0 16 16",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.668 13.989a4.333 4.333 0 01-1.957-8 5.334 5.334 0 0110.581 0 4.333 4.333 0 01-1.957 8V14H4.668v-.012zm1.608-3.47l1.65-1.65 1.65 1.65.943-.943-1.65-1.65 1.65-1.65-.943-.943-1.65 1.65-1.65-1.65-.943.943 1.65 1.65-1.65 1.65.943.943z",
    clipRule: "evenodd"
  })));
};

var SvgUnpublish = function SvgUnpublish(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$H({
    as: SvgComponent$H
  }, props));
};

var _path$E;

function ownKeys$I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$I(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$I(Object(source), !0).forEach(function (key) { _defineProperty$I(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$I(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var SvgComponent$I = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
  })));
};

var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$I({
    as: SvgComponent$I
  }, props));
};

var _path$F;

function ownKeys$J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$J(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$J(Object(source), !0).forEach(function (key) { _defineProperty$J(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$J(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var SvgComponent$J = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 5.638-6.364 6.364L12 18.366l6.364-6.364L12 5.638Zm.707-2.12a1 1 0 0 0-1.414 0l-7.778 7.777a1 1 0 0 0 0 1.415l7.778 7.778a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 0 0 0-1.415l-7.778-7.778Z"
  })));
};

var SvgBasicComponent = function SvgBasicComponent(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$J({
    as: SvgComponent$J
  }, props));
};

var _path$G;

function ownKeys$K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$K(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$K(Object(source), !0).forEach(function (key) { _defineProperty$K(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$K(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var SvgComponent$K = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.879 5.64 12 3.518l2.121 2.122L12 7.76 9.879 5.64Zm1.414-4.243a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-3.536 3.535a1 1 0 0 1-1.414 0L7.757 6.347a1 1 0 0 1 0-1.414l3.536-3.536ZM3.515 12.004l2.122-2.121 2.121 2.12-2.121 2.122-2.122-2.121ZM4.93 7.76a1 1 0 0 1 1.414 0l3.535 3.536a1 1 0 0 1 0 1.414l-3.535 3.536a1 1 0 0 1-1.414 0L1.394 12.71a1 1 0 0 1 0-1.414L4.93 7.76Zm13.433 2.122-2.121 2.12 2.121 2.122 2.122-2.121-2.122-2.121Zm.707-2.122a1 1 0 0 0-1.414 0l-3.535 3.536a1 1 0 0 0 0 1.414l3.535 3.536a1 1 0 0 0 1.414 0l3.536-3.536a1 1 0 0 0 0-1.414L19.07 7.76ZM9.88 18.368 12 16.247l2.121 2.12L12 20.49l-2.121-2.121Zm1.414-4.243a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-3.536 3.535a1 1 0 0 1-1.414 0l-3.536-3.535a1 1 0 0 1 0-1.414l3.536-3.536Z"
  })));
};

var SvgModularComponent = function SvgModularComponent(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$K({
    as: SvgComponent$K
  }, props));
};

var _path$H;

function ownKeys$L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$L(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$L(Object(source), !0).forEach(function (key) { _defineProperty$L(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$L(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var SvgComponent$L = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z"
  })));
};

var SvgCaretDownFill = function SvgCaretDownFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$L({
    as: SvgComponent$L
  }, props));
};

var _path$I;

function ownKeys$M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$M(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$M(Object(source), !0).forEach(function (key) { _defineProperty$M(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$M(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var SvgComponent$M = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M7 14l5-5 5 5z"
  })));
};

var SvgCaretUpFill = function SvgCaretUpFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$M({
    as: SvgComponent$M
  }, props));
};

var _path$J;

function ownKeys$N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$N(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$N(Object(source), !0).forEach(function (key) { _defineProperty$N(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$N(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var SvgComponent$N = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    d: "m10 12 4-4v8l-4-4Z"
  })));
};

var SvgCaretLeftFill = function SvgCaretLeftFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$N({
    as: SvgComponent$N
  }, props));
};

var _path$K;

function ownKeys$O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$O(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$O(Object(source), !0).forEach(function (key) { _defineProperty$O(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$O(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var SvgComponent$O = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "m14 12-4 4V8l4 4Z"
  })));
};

var SvgCaretRightFill = function SvgCaretRightFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$O({
    as: SvgComponent$O
  }, props));
};

var _path$L;

function ownKeys$P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$P(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$P(Object(source), !0).forEach(function (key) { _defineProperty$P(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$P(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var SvgComponent$P = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a1 1 0 00-1 1v2H4v2h16V5h-4V3a1 1 0 00-1-1H9zm1 2v1h4V4h-4zM5 8h14v13a1 1 0 01-1 1H6a1 1 0 01-1-1V8z"
  })));
};

var SvgDeleteFilled = function SvgDeleteFilled(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$P({
    as: SvgComponent$P
  }, props));
};

var _path$M;

function ownKeys$Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Q(Object(source), !0).forEach(function (key) { _defineProperty$Q(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$Q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var SvgComponent$Q = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.86708 20.5419c-.19372.4217.24145.8568.66309.6631l5.31402-2.4416L20.865 6.74263c.3905-.39052.3905-1.02369 0-1.41421L18.7437 3.2071c-.3905-.39053-1.0237-.39053-1.4142 0L5.30866 15.2279l-2.44158 5.314zm3.47656-4.6399l-2.09291 3.9194 3.92294-2.0894L19.586 6.31965c.1562-.15621.1562-.40947 0-.56568l-1.2643-1.26435c-.1562-.15621-.4095-.15621-.5657 0L6.34364 15.902z",
    clipRule: "evenodd"
  })));
};

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$Q({
    as: SvgComponent$Q
  }, props));
};

var _path$N;

function ownKeys$R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$R(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$R(Object(source), !0).forEach(function (key) { _defineProperty$R(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$R(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var SvgComponent$R = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    d: "m15.728 9.657-1.414-1.414L5 17.557v1.414h1.414l9.314-9.314Zm1.414-1.414 1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414Zm-9.9 12.728H3v-4.243L16.435 3.293a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 20.97h-.001Z"
  })));
};

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$R({
    as: SvgComponent$R
  }, props));
};

var _path$O;

function ownKeys$S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$S(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$S(Object(source), !0).forEach(function (key) { _defineProperty$S(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$S(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var SvgComponent$S = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 6.829l4.242 4.243-9.9 9.899H3v-4.243l9.9-9.9zm1.414-1.414l2.121-2.122a1 1 0 011.414 0l2.829 2.829a1 1 0 010 1.414l-2.122 2.12-4.242-4.241z"
  })));
};

var SvgPencilFill = function SvgPencilFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$S({
    as: SvgComponent$S
  }, props));
};

var _path$P;

function ownKeys$T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$T(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$T(Object(source), !0).forEach(function (key) { _defineProperty$T(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$T(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var SvgComponent$T = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M12.364 10.95 17.314 6l1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95L6 17.314l4.95-4.95L6 7.414 7.414 6l4.95 4.95Z"
  })));
};

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$T({
    as: SvgComponent$T
  }, props));
};

var _path$Q;

function ownKeys$U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$U(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$U(Object(source), !0).forEach(function (key) { _defineProperty$U(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$U(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var SvgComponent$U = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.6 21.5a.62.62 0 01-.32-.09l-3.2-2a.61.61 0 01-.28-.51v-8.25L2.68 3.52a.568.568 0 01-.13-.65c.1-.22.31-.37.55-.37h17.8a.6.6 0 01.55.37c.09.22.05.48-.13.65l-7.12 7.13V20.9c0 .22-.12.42-.31.52a.51.51 0 01-.29.08zM11 18.57l2 1.25V10.4c0-.16.06-.31.18-.42l6.28-6.28H4.55l6.28 6.28c.11.11.17.26.17.42v8.17z",
    clipRule: "evenodd"
  })));
};

var SvgFilterFunnel = function SvgFilterFunnel(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$U({
    as: SvgComponent$U
  }, props));
};

var _path$R;

function ownKeys$V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$V(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$V(Object(source), !0).forEach(function (key) { _defineProperty$V(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$V(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var SvgComponent$V = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  })));
};

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$V({
    as: SvgComponent$V
  }, props));
};

var _path$S;

function ownKeys$W(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$W(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$W(Object(source), !0).forEach(function (key) { _defineProperty$W(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$W(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$W(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var SvgComponent$W = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  })));
};

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$W({
    as: SvgComponent$W
  }, props));
};

var _path$T;

function ownKeys$X(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$X(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$X(Object(source), !0).forEach(function (key) { _defineProperty$X(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$X(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$X(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var SvgComponent$X = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  })));
};

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$X({
    as: SvgComponent$X
  }, props));
};

var _path$U;

function ownKeys$Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Y(Object(source), !0).forEach(function (key) { _defineProperty$Y(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$Y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var SvgComponent$Y = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    className: "MuiSvgIcon-root jss246",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    tabIndex: "-1",
    "data-icon": "hygraph-icon",
    focusable: "false"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  })));
};

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$Y({
    as: SvgComponent$Y
  }, props));
};

var _path$V;

function ownKeys$Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Z(Object(source), !0).forEach(function (key) { _defineProperty$Z(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$Z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var SvgComponent$Z = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    className: "MuiSvgIcon-root jss246",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    tabIndex: "-1",
    "data-icon": "hygraph-icon",
    focusable: "false"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  })));
};

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$Z({
    as: SvgComponent$Z
  }, props));
};

var _path$W;

function ownKeys$_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$_(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$_(Object(source), !0).forEach(function (key) { _defineProperty$_(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$_(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var SvgComponent$_ = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    d: "M5.463 4.433A9.961 9.961 0 0 1 12 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 0 0 6.46 6.228l-.997-1.795Zm13.074 15.134A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0 0 13.54 5.772l.997 1.795Z"
  })));
};

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$_({
    as: SvgComponent$_
  }, props));
};

var _path$X;

function ownKeys$$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$$(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$$(Object(source), !0).forEach(function (key) { _defineProperty$$(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$$(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var SvgComponent$$ = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    d: "M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 0114 0v1zM5 12v8h14v-8H5zm6 2h2v4h-2v-4zm6-4V9A5 5 0 007 9v1h10z"
  })));
};

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$$({
    as: SvgComponent$$
  }, props));
};

var _path$Y;

function ownKeys$10(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$10(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$10(Object(source), !0).forEach(function (key) { _defineProperty$10(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$10(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$10(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var SvgComponent$10 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.002h13a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1v-10a1 1 0 011-1h1v-1a7 7 0 0113.262-3.13l-1.789.894A5 5 0 007 9.003v1zm-2 2v8h14v-8H5zm5 3h4v2h-4v-2z"
  })));
};

var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$10({
    as: SvgComponent$10
  }, props));
};

var _path$Z;

function ownKeys$11(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$11(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$11(Object(source), !0).forEach(function (key) { _defineProperty$11(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$11(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$11(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var SvgComponent$11 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5h4v4H5V5zM3 5a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2 10h4v4H5v-4zm-2 0a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4zM19 5h-4v4h4V5zm-4-2a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2h-4zm0 12h4v4h-4v-4zm-2 0a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4z"
  })));
};

var SvgExtension = function SvgExtension(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$11({
    as: SvgComponent$11
  }, props));
};

var _path$_, _path2$1, _path3, _path4, _path5, _path6, _path7, _path8;

function ownKeys$12(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$12(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$12(Object(source), !0).forEach(function (key) { _defineProperty$12(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$12(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$12(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var SvgComponent$12 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5C21 20.3284 20.3284 21 19.5 21V15H21V19.5Z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5C3 20.3284 3.67157 21 4.5 21V15H3V19.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5C21 20.3284 20.3284 21 19.5 21H15V19.5H21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5C3 20.3284 3.67157 21 4.5 21H9V19.5H3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5C21 3.67157 20.3284 3 19.5 3V9H21V4.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5C21 3.67157 20.3284 3 19.5 3H15V4.5H21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5C3 3.67157 3.67157 3 4.5 3V9H3V4.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5C3 3.67157 3.67157 3 4.5 3H9V4.5H3Z"
  })));
};

var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$12({
    as: SvgComponent$12
  }, props));
};

var _path$$;

function ownKeys$13(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$13(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$13(Object(source), !0).forEach(function (key) { _defineProperty$13(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$13(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$13(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var SvgComponent$13 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M16 9a1 1 0 01-1-1V3h1.5v4.5H21V9h-5zM9 16a1 1 0 00-1-1H3v1.5h4.5V21H9v-5zM15 16a1 1 0 011-1h5v1.5h-4.5V21H15v-5zM9 8a1 1 0 01-1 1H3V7.5h4.5V3H9v5z"
  })));
};

var SvgFullscreenExit = function SvgFullscreenExit(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$13({
    as: SvgComponent$13
  }, props));
};

var _path$10, _path2$2;

function ownKeys$14(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$14(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$14(Object(source), !0).forEach(function (key) { _defineProperty$14(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$14(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$14(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var SvgComponent$14 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm0 16.5h-15V15l3.75-3.75 4.193 4.193a1.5 1.5 0 002.114 0l1.193-1.193L19.5 18v1.5zm0-3.623l-2.692-2.692a1.5 1.5 0 00-2.115 0L13.5 14.377l-4.193-4.192a1.5 1.5 0 00-2.115 0L4.5 12.877V4.5h15v11.377z"
  })));
};

var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$14({
    as: SvgComponent$14
  }, props));
};

var _path$11;

function ownKeys$15(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$15(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$15(Object(source), !0).forEach(function (key) { _defineProperty$15(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$15(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$15(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var SvgComponent$15 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04 11.794H4.592A6.794 6.794 0 017.537 7.16l1.351-.906L8.051 5l-1.352.906A8.304 8.304 0 003 12.814v5.02a1.51 1.51 0 001.51 1.51h4.53a1.51 1.51 0 001.51-1.51v-4.53a1.51 1.51 0 00-1.51-1.51zM19.609 11.794h-4.447a6.794 6.794 0 012.944-4.635l1.352-.906L18.628 5l-1.36.906a8.304 8.304 0 00-3.699 6.908v5.02a1.51 1.51 0 001.51 1.51h4.53a1.51 1.51 0 001.51-1.51v-4.53a1.51 1.51 0 00-1.51-1.51z"
  })));
};

var SvgFormatQuote = function SvgFormatQuote(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$15({
    as: SvgComponent$15
  }, props));
};

var _path$12;

function ownKeys$16(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$16(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$16(Object(source), !0).forEach(function (key) { _defineProperty$16(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$16(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$16(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var SvgComponent$16 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.63 21H5V3h7.93c.935 0 1.85.287 2.638.827a5.158 5.158 0 011.807 2.22c.392.91.534 1.92.407 2.913a5.437 5.437 0 01-1.12 2.69 5.286 5.286 0 011.647 2.65 5.61 5.61 0 01-.084 3.183 5.23 5.23 0 01-1.785 2.546c-.826.63-1.815.97-2.83.971h.02zm-5.831-3h5.812a2.03 2.03 0 001.484-.659c.394-.422.615-.994.615-1.591s-.221-1.169-.615-1.591a2.03 2.03 0 00-1.484-.659H7.799V18zm0-7.5h5.13a2.03 2.03 0 001.485-.659c.394-.422.615-.994.615-1.591s-.221-1.17-.615-1.591A2.03 2.03 0 0012.93 6H7.799v4.5z"
  })));
};

var SvgFormatBold = function SvgFormatBold(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$16({
    as: SvgComponent$16
  }, props));
};

var _path$13;

function ownKeys$17(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$17(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$17(Object(source), !0).forEach(function (key) { _defineProperty$17(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$17(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$17(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var SvgComponent$17 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.546 5.44a1.5 1.5 0 00-2.121 0L9 12.863l2.121 2.121 7.425-7.424a1.5 1.5 0 000-2.122zM8.125 14.378c-1.037 0-1.875.765-1.875 1.714 0 .748-.725 1.143-1.25 1.143.575.697 1.556 1.143 2.5 1.143 1.381 0 2.5-1.023 2.5-2.286 0-.949-.838-1.714-1.875-1.714z"
  })));
};

var SvgBrush = function SvgBrush(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$17({
    as: SvgComponent$17
  }, props));
};

var _path$14;

function ownKeys$18(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$18(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$18(Object(source), !0).forEach(function (key) { _defineProperty$18(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$18(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$18(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var SvgComponent$18 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.097 13.075l-5.075 5.075L16 17.128l4.046-4.053L16 9.022 17.022 8l5.075 5.075zM1 13.075L6.075 8l1.022 1.022-4.045 4.053 4.045 4.053-1.022 1.022L1 13.075zM13.063 5L9.278 19.125l1.4.375 3.786-14.125-1.4-.375z"
  })));
};

var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$18({
    as: SvgComponent$18
  }, props));
};

var _path$15;

function ownKeys$19(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$19(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$19(Object(source), !0).forEach(function (key) { _defineProperty$19(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$19(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$19(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var SvgComponent$19 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 19.5v-5h9v5h-9zm9-6.5h-9V8h9v5zM15 8v11.5h4.5V8H15zM3 4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4z"
  })));
};

var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$19({
    as: SvgComponent$19
  }, props));
};

var _path$16;

function ownKeys$1a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1a(Object(source), !0).forEach(function (key) { _defineProperty$1a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var SvgComponent$1a = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V3H8v2h5.14L8.77 19H3v2h13v-2h-5.14l4.37-14H21z"
  })));
};

var SvgFormatItalic = function SvgFormatItalic(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1a({
    as: SvgComponent$1a
  }, props));
};

var _path$17;

function ownKeys$1b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1b(Object(source), !0).forEach(function (key) { _defineProperty$1b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var SvgComponent$1b = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25h10.5v1.5H9v-1.5zM9 11.25h10.5v1.5H9v-1.5zM9 17.25h10.5v1.5H9v-1.5zM6.5 9.3V4.5h-1v.6h-1v1.2h1v3h-1v1.2h3V9.3h-1zM7.5 19.5h-3v-2.4c0-.318.105-.623.293-.849A.924.924 0 015.5 15.9h1v-1.2h-2v-1.2h2c.265 0 .52.126.707.351.188.225.293.53.293.849v1.2c0 .318-.105.623-.293.848a.924.924 0 01-.707.352h-1v1.2h2v1.2z"
  })));
};

var SvgFormatListNumbered = function SvgFormatListNumbered(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1b({
    as: SvgComponent$1b
  }, props));
};

var _path$18;

function ownKeys$1c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1c(Object(source), !0).forEach(function (key) { _defineProperty$1c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var SvgComponent$1c = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7 18.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM10 5.75h10.5v1.5H10v-1.5zM10 11.75h10.5v1.5H10v-1.5zM10 17.75h10.5v1.5H10v-1.5z"
  })));
};

var SvgFormatListBulleted = function SvgFormatListBulleted(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1c({
    as: SvgComponent$1c
  }, props));
};

var _path$19;

function ownKeys$1d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1d(Object(source), !0).forEach(function (key) { _defineProperty$1d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var SvgComponent$1d = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14v-4H11v4H4.5zm0 1.5v4H11v-4H4.5zm8 0v4h7v-4h-7zm7-1.5v-4h-7v4h7zm0-5.5h-15v-4h15v4zM3 4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4z"
  })));
};

var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1d({
    as: SvgComponent$1d
  }, props));
};

var _path$1a;

function ownKeys$1e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1e(Object(source), !0).forEach(function (key) { _defineProperty$1e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var SvgComponent$1e = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.45h18V19.5H3v1.95zM12 18a6.088 6.088 0 01-4.243-1.709A5.752 5.752 0 016 12.167V3h1.714v9.167c0 1.105.452 2.165 1.256 2.946a4.349 4.349 0 003.03 1.22 4.349 4.349 0 003.03-1.22 4.109 4.109 0 001.256-2.946V3H18v9.167c0 1.547-.632 3.03-1.757 4.124A6.088 6.088 0 0112 18z"
  })));
};

var SvgFormatUnderlined = function SvgFormatUnderlined(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1e({
    as: SvgComponent$1e
  }, props));
};

var _path$1b;

function ownKeys$1f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1f(Object(source), !0).forEach(function (key) { _defineProperty$1f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var SvgComponent$1f = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    className: "MuiSvgIcon-root jss246",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    tabIndex: "-1",
    "data-icon": "hygraph-icon",
    focusable: "false"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
  })));
};

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1f({
    as: SvgComponent$1f
  }, props));
};

var _path$1c;

function ownKeys$1g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1g(Object(source), !0).forEach(function (key) { _defineProperty$1g(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var SvgComponent$1g = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z"
  })));
};

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1g({
    as: SvgComponent$1g
  }, props));
};

var _path$1d;

function ownKeys$1h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1h(Object(source), !0).forEach(function (key) { _defineProperty$1h(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var SvgComponent$1h = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z"
  })));
};

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1h({
    as: SvgComponent$1h
  }, props));
};

var _path$1e;

function ownKeys$1i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1i(Object(source), !0).forEach(function (key) { _defineProperty$1i(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var SvgComponent$1i = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.638c0-.865.11-1.703.316-2.504A3 3 0 0 0 4.99 4.505 9.99 9.99 0 0 1 9.325 2a3 3 0 0 0 5.348 0 9.99 9.99 0 0 1 4.335 2.505 3 3 0 0 0 2.675 4.63 10.036 10.036 0 0 1 0 5.007 3 3 0 0 0-2.675 4.629 9.99 9.99 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 9.99 9.99 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63A10.056 10.056 0 0 1 2 11.638Zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0 1 12 17.638c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75a4.993 4.993 0 0 1 .564-3.524 4.993 4.993 0 0 1 2.77-2.25 8.134 8.134 0 0 0 0-1.5 4.993 4.993 0 0 1-2.771-2.25 4.993 4.993 0 0 1-.564-3.524 7.988 7.988 0 0 0-1.297-.75A4.993 4.993 0 0 1 12 5.638a4.993 4.993 0 0 1-3.335-1.274 7.99 7.99 0 0 0-1.297.75 4.993 4.993 0 0 1-.564 3.524 4.993 4.993 0 0 1-2.77 2.25 8.125 8.125 0 0 0 0 1.5 4.993 4.993 0 0 1 2.771 2.25h-.001Zm5.196 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })));
};

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1i({
    as: SvgComponent$1i
  }, props));
};

var _path$1f;

function ownKeys$1j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1j(Object(source), !0).forEach(function (key) { _defineProperty$1j(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var SvgComponent$1j = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 7.646l-5.656 5.657a1 1 0 101.414 1.414l5.657-5.656a3 3 0 00-4.243-4.243l-5.657 5.657a5 5 0 107.071 7.07l5.657-5.656 1.414 1.414-5.657 5.657a7.002 7.002 0 01-11.417-7.63A7 7 0 015.05 9.06l5.658-5.656a5 5 0 017.07 7.07l-5.656 5.659a3.002 3.002 0 01-4.243-4.244l5.657-5.657 1.414 1.414z"
  })));
};

var SvgFieldAsset = function SvgFieldAsset(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1j({
    as: SvgComponent$1j
  }, props));
};

var _path$1g;

function ownKeys$1k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1k(Object(source), !0).forEach(function (key) { _defineProperty$1k(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var SvgComponent$1k = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    d: "M8 7a5 5 0 100 10h8a5 5 0 100-10H8zm0-2h8a7 7 0 110 14H8A7 7 0 118 5zm0 10a3 3 0 110-6 3 3 0 010 6z"
  })));
};

var SvgFieldCheckbox = function SvgFieldCheckbox(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1k({
    as: SvgComponent$1k
  }, props));
};

var _path$1h;

function ownKeys$1l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1l(Object(source), !0).forEach(function (key) { _defineProperty$1l(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var SvgComponent$1l = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 01-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2zm-1.189 16.111a3.665 3.665 0 013.667-3.667h1.966A3.558 3.558 0 0020 10.89C20 7.139 16.468 4 12 4a8 8 0 00-.676 15.972 3.649 3.649 0 01-.513-1.86v-.001zM7.5 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm9 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM12 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
  })));
};

var SvgFieldColor = function SvgFieldColor(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1l({
    as: SvgComponent$1l
  }, props));
};

var _path$1i;

function ownKeys$1m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1m(Object(source), !0).forEach(function (key) { _defineProperty$1m(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var SvgComponent$1m = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4h4a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h4V2h2v2h6V2h2v2zm-2 2H9v2H7V6H4v4h16V6h-3v2h-2V6zm5 6H4v8h16v-8zm-10 2h2v2h2v2h-4v-4z"
  })));
};

var SvgFieldDateTime = function SvgFieldDateTime(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1m({
    as: SvgComponent$1m
  }, props));
};

var _path$1j;

function ownKeys$1n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1n(Object(source), !0).forEach(function (key) { _defineProperty$1n(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var SvgComponent$1n = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h4a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h4V2h2v2h6V2h2v2zm-2 2H9v2H7V6H4v4h16V6h-3v2h-2V6zm5 6H4v8h16v-8z"
  })));
};

var SvgFieldDate = function SvgFieldDate(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1n({
    as: SvgComponent$1n
  }, props));
};

var _path$1k;

function ownKeys$1o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1o(Object(source), !0).forEach(function (key) { _defineProperty$1o(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var SvgComponent$1o = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7h18l-9 11L3 7zm4.31 2.092L12 14.824l4.69-5.732H7.31z"
  })));
};

var SvgFieldDropdown = function SvgFieldDropdown(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1o({
    as: SvgComponent$1o
  }, props));
};

var _path$1l;

function ownKeys$1p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1p(Object(source), !0).forEach(function (key) { _defineProperty$1p(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var SvgComponent$1p = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5H4v2h4v3c0 2.432-.37 4.219-1.048 5.366C6.32 16.434 5.4 17 4 17v2c2.1 0 3.68-.934 4.673-2.616C9.62 14.78 10 12.568 10 10V7h4v9a3 3 0 106 0h-2a1 1 0 11-2 0V7h4V5z"
  })));
};

var SvgFieldFloat = function SvgFieldFloat(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1p({
    as: SvgComponent$1p
  }, props));
};

var _path$1m;

function ownKeys$1q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1q(Object(source), !0).forEach(function (key) { _defineProperty$1q(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var SvgComponent$1q = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    d: "M7.784 14l.42-4H4V8h4.415l.525-5h2.011l-.525 5h3.989l.525-5h2.011l-.525 5H20v2h-3.784l-.42 4H20v2h-4.415l-.525 5h-2.011l.525-5H9.585l-.525 5H7.049l.525-5H4v-2h3.784zm2.011 0h3.99l.42-4h-3.99l-.42 4z"
  })));
};

var SvgFieldId = function SvgFieldId(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1q({
    as: SvgComponent$1q
  }, props));
};

var _path$1n;

function ownKeys$1r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1r(Object(source), !0).forEach(function (key) { _defineProperty$1r(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var SvgComponent$1r = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4L2 14v2h7v4h2v-4h2v-2h-2V4H9zm0 3.486L4.44 14H9V7.486zM16 8a2 2 0 114 0c0 .342-.077.663-.226.944L14 18v2h8v-2h-5.628l5.071-7.954-.004-.002.026-.044A4 4 0 1014 8h2z"
  })));
};

var SvgFieldInteger = function SvgFieldInteger(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1r({
    as: SvgComponent$1r
  }, props));
};

var _path$1o;

function ownKeys$1s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1s(Object(source), !0).forEach(function (key) { _defineProperty$1s(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var SvgComponent$1s = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-3.7a1.5 1.5 0 00-1.5-1.5H2v-1.6h.5A1.5 1.5 0 004 9.7V6a3 3 0 013-3h1v2H7a1 1 0 00-1 1v4.1A2 2 0 014.626 12 2 2 0 016 13.9V18a1 1 0 001 1h1v2H7a3 3 0 01-3-3zm16-3.7V18a3 3 0 01-3 3h-1v-2h1a1 1 0 001-1v-4.1a2 2 0 011.374-1.9A2 2 0 0118 10.1V6a1 1 0 00-1-1h-1V3h1a3 3 0 013 3v3.7a1.5 1.5 0 001.5 1.5h.5v1.6h-.5a1.5 1.5 0 00-1.5 1.5z"
  })));
};

var SvgFieldJson = function SvgFieldJson(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1s({
    as: SvgComponent$1s
  }, props));
};

var _path$1p;

function ownKeys$1t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1t(Object(source), !0).forEach(function (key) { _defineProperty$1t(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var SvgComponent$1t = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.9l4.95-4.95a7 7 0 10-9.9 0L12 19.9zm0 2.828l-6.364-6.364a9 9 0 1112.728 0L12 22.728zM12 12a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 110-8 4 4 0 010 8z"
  })));
};

var SvgFieldLocation = function SvgFieldLocation(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1t({
    as: SvgComponent$1t
  }, props));
};

var _path$1q;

function ownKeys$1u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1u(Object(source), !0).forEach(function (key) { _defineProperty$1u(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var SvgComponent$1u = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.997h1.996v-7.292l3.011 3.177 3.006-3.177v7.292h2.018V7h-2.018l-3.006 3.705L4.997 7H3v10.997zm18-2.98h-1.989V7h-2.01v8.018h-2.032l3.033 2.979L21 15.017z"
  })));
};

var SvgFieldMarkdown = function SvgFieldMarkdown(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1u({
    as: SvgComponent$1u
  }, props));
};

var _path$1r;

function ownKeys$1v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1v(Object(source), !0).forEach(function (key) { _defineProperty$1v(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var SvgComponent$1v = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5v15H8V5H2V3h14v2h-6zm2 6h10v2H12v-2zm10 7H12v2h10v-2z"
  })));
};

var SvgFieldMultiLine = function SvgFieldMultiLine(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1v({
    as: SvgComponent$1v
  }, props));
};

var _g$2;

function ownKeys$1w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1w(Object(source), !0).forEach(function (key) { _defineProperty$1w(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var SvgComponent$1w = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    viewBox: "0 0 32 32",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.046 16H24.61M7.013 15.047l18.193-9.375M7.026 17.028l18.18 9.019",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 32 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.046 16H24.61M7.013 15.047l18.193-9.375M7.026 17.028l18.18 9.019",
    strokeLinecap: "square"
  })))));
};

var SvgFieldRelationManyToMany = function SvgFieldRelationManyToMany(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1w({
    as: SvgComponent$1w
  }, props));
};

var _g$3;

function ownKeys$1x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1x(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1x(Object(source), !0).forEach(function (key) { _defineProperty$1x(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var SvgComponent$1x = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    viewBox: "0 0 32 32",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 32 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.046 16H24.61M7.013 15.047l18.193-9.375M7.026 17.028l18.18 9.019",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.046 4H17.61",
    strokeLinecap: "square"
  })))));
};

var SvgFieldRelationManyToOne = function SvgFieldRelationManyToOne(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1x({
    as: SvgComponent$1x
  }, props));
};

var _g$4;

function ownKeys$1y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1y(Object(source), !0).forEach(function (key) { _defineProperty$1y(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var SvgComponent$1y = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    viewBox: "0 0 32 32",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.046 16H24.61M7.013 15.047l18.193-9.375M7.026 17.028l18.18 9.019",
    strokeLinecap: "square"
  }))));
};

var SvgFieldRelationOneToMany = function SvgFieldRelationOneToMany(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1y({
    as: SvgComponent$1y
  }, props));
};

var _g$5;

function ownKeys$1z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1z(Object(source), !0).forEach(function (key) { _defineProperty$1z(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var SvgComponent$1z = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    viewBox: "0 0 32 8",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 32 0)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.046 4H24.61",
    strokeLinecap: "square"
  }))));
};

var SvgFieldRelationOneToOne = function SvgFieldRelationOneToOne(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1z({
    as: SvgComponent$1z
  }, props));
};

var _g$6, _defs$1;

function ownKeys$1A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1A(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1A(Object(source), !0).forEach(function (key) { _defineProperty$1A(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1A(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var SvgComponent$1A = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.899V11.9a7.001 7.001 0 01-7 7H8A7 7 0 018 4.899V6.9a5 5 0 100 10h.501a5 5 0 005-5v-2h2V9.9zm.5 9V16.9a5.002 5.002 0 005.023-5A5 5 0 0016 6.9h-.5a5 5 0 00-5 5v2h-2v-2a7 7 0 017-7h.5a7 7 0 110 14.001V18.9z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

var SvgFieldRelation = function SvgFieldRelation(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1A({
    as: SvgComponent$1A
  }, props));
};

var _path$1s;

function ownKeys$1B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1B(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1B(Object(source), !0).forEach(function (key) { _defineProperty$1B(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1B(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var SvgComponent$1B = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    d: "M19 2a1 1 0 011 1v3.757l-2 2V4H4v16h14v-2.758l2-2V21a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h16zm1.778 6.808l1.414 1.414L14.414 18l-1.416-.002.002-1.412 7.778-7.778zM12 12v2H7v-2h5zm3-4v2H7V8h8z"
  })));
};

var SvgFieldRichText = function SvgFieldRichText(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1B({
    as: SvgComponent$1B
  }, props));
};

var _path$1t;

function ownKeys$1C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1C(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1C(Object(source), !0).forEach(function (key) { _defineProperty$1C(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1C(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var SvgComponent$1C = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    d: "M13 5v15h-2V5H5V3h14v2h-6z"
  })));
};

var SvgFieldSingleLine = function SvgFieldSingleLine(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1C({
    as: SvgComponent$1C
  }, props));
};

var _path$1u;

function ownKeys$1D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1D(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1D(Object(source), !0).forEach(function (key) { _defineProperty$1D(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1D(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var SvgComponent$1D = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 101.865-5.135L8 9H2V3l2.447 2.446A9.98 9.98 0 0112 2zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2z"
  })));
};

var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1D({
    as: SvgComponent$1D
  }, props));
};

var _path$1v;

function ownKeys$1E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1E(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1E(Object(source), !0).forEach(function (key) { _defineProperty$1E(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1E(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var SvgComponent$1E = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.17 16.598c-.15 0-.31.06-.42.18L6.57 18.95V3.598c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6V18.95l-2.18-2.172a.6.6 0 00-.85 0 .6.6 0 000 .85l3.2 3.2c.23.23.61.23.85 0l3.2-3.2a.61.61 0 000-.85.576.576 0 00-.42-.18zm12.8-5.2H9.17c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h12.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6zm-12.8-4.2h8.8c.33 0 .6.27.6.6 0 .33-.27.6-.6.6h-8.8c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6zm0-4.2h4.8c.33 0 .6.27.6.6 0 .33-.27.6-.6.6h-4.8c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6z",
    clipRule: "evenodd"
  })));
};

var SvgOrderAsc = function SvgOrderAsc(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1E({
    as: SvgComponent$1E
  }, props));
};

var _path$1w;

function ownKeys$1F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1F(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1F(Object(source), !0).forEach(function (key) { _defineProperty$1F(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1F(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var SvgComponent$1F = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.17 7.4c-.15 0-.31-.06-.42-.18L6.57 5.048V20.4c0 .33-.27.6-.6.6-.33 0-.6-.27-.6-.6V5.048L3.19 7.22a.6.6 0 01-.85 0 .6.6 0 010-.85l3.2-3.2a.61.61 0 01.85 0l3.2 3.2c.23.23.23.61 0 .85-.11.12-.27.18-.42.18zm12.8 5.2H9.17c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6h12.8c.33 0 .6.27.6.6 0 .33-.27.6-.6.6zm-12.8 4.2h8.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6h-8.8c-.33 0-.6.27-.6.6 0 .33.27.6.6.6zm0 4.2h4.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6h-4.8c-.33 0-.6.27-.6.6 0 .33.27.6.6.6z",
    clipRule: "evenodd"
  })));
};

var SvgOrderDesc = function SvgOrderDesc(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1F({
    as: SvgComponent$1F
  }, props));
};

var _path$1x;

function ownKeys$1G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1G(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1G(Object(source), !0).forEach(function (key) { _defineProperty$1G(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1G(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var SvgComponent$1G = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7a2 2 0 012-2h5.764a2 2 0 011.789 1.106L12.5 8H15v1.2h-3.282l-.103-.2H11.6l-1.124-2.247a1 1 0 00-.894-.553H4.2a1 1 0 00-1 1v11.6h15.6V12H20v7a1 1 0 01-1 1H3a1 1 0 01-1-1V7zm16.4-1.5a.5.5 0 01.5-.5h.2a.5.5 0 01.5.5v1.9h1.9a.5.5 0 01.5.5v.2a.5.5 0 01-.5.5h-1.9v1.9a.5.5 0 01-.5.5h-.2a.5.5 0 01-.5-.5V8.6h-1.9a.5.5 0 01-.5-.5v-.2a.5.5 0 01.5-.5h1.9V5.5z",
    clipRule: "evenodd"
  })));
};

var SvgNewFolder = function SvgNewFolder(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1G({
    as: SvgComponent$1G
  }, props));
};

var _path$1y;

function ownKeys$1H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1H(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1H(Object(source), !0).forEach(function (key) { _defineProperty$1H(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1H(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var SvgComponent$1H = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10l4-4-4-4v3h-3.377a4.768 4.768 0 00-4.575 3.423c.711.322 1.33.813 1.803 1.423l.002-.075a2.77 2.77 0 012.602-2.766L14.623 7H18v3zm-6.152 4.02a4.77 4.77 0 00-4.766-4.558H2v2h5.082l.169.005a2.771 2.771 0 012.602 2.765l.004.213a4.771 4.771 0 004.767 4.558H18V22l4-4-4-4v3.003h-3.377l-.168-.005a2.77 2.77 0 01-2.602-2.766l-.005-.212z",
    clipRule: "evenodd"
  })));
};

var SvgBranch = function SvgBranch(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1H({
    as: SvgComponent$1H
  }, props));
};

var _path$1z;

function ownKeys$1I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1I(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1I(Object(source), !0).forEach(function (key) { _defineProperty$1I(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1I(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var SvgComponent$1I = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4v2h7a1 1 0 011 1v9h2V4H9zm8 14v3a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h3V3a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1h-3zM5 20V8h10v12H5z",
    clipRule: "evenodd"
  })));
};

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1I({
    as: SvgComponent$1I
  }, props));
};

var _path$1A;

function ownKeys$1J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1J(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1J(Object(source), !0).forEach(function (key) { _defineProperty$1J(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1J(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var SvgComponent$1J = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H20L11 23V14H4L13 1V10Z"
  })));
};

var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1J({
    as: SvgComponent$1J
  }, props));
};

var _path$1B;

function ownKeys$1K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1K(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1K(Object(source), !0).forEach(function (key) { _defineProperty$1K(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1K(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var SvgComponent$1K = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    d: "M13.435 10H20l-2.686 3.88L13.435 10zM13 9.565V1L9.496 6.061 13 9.565zM8.34 7.732h-.001L3.414 2.809 2 4.222l5.182 5.182L4 14h7v9l4-5.778 5.385 5.385 1.414-1.415-5.642-5.641L8.34 7.732z",
    clipRule: "evenodd"
  })));
};

var SvgFlashOff = function SvgFlashOff(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1K({
    as: SvgComponent$1K
  }, props));
};

var _path$1C;

function ownKeys$1L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1L(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1L(Object(source), !0).forEach(function (key) { _defineProperty$1L(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1L(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var SvgComponent$1L = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10V10.5H13H19.0457L11.5 21.3994V14V13.5H11H4.95428L12.5 2.60063V10Z",
    stroke: "currentColor",
    fill: "none"
  })));
};

var SvgFlashlightThin = function SvgFlashlightThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1L({
    as: SvgComponent$1L
  }, props));
};

var _path$1D;

function ownKeys$1M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1M(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1M(Object(source), !0).forEach(function (key) { _defineProperty$1M(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1M(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var SvgComponent$1M = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16.001A8 8 0 0012 20zm1-8h4v2h-6V7h2v5z"
  })));
};

var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1M({
    as: SvgComponent$1M
  }, props));
};

var _path$1E;

function ownKeys$1N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1N(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1N(Object(source), !0).forEach(function (key) { _defineProperty$1N(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1N(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var SvgComponent$1N = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
  })));
};

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1N({
    as: SvgComponent$1N
  }, props));
};

var _path$1F;

function ownKeys$1O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1O(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1O(Object(source), !0).forEach(function (key) { _defineProperty$1O(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1O(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var SvgComponent$1O = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 01-.993.993H3.993A.994.994 0 013 20.007V3.993zM5 5v14h14V5H5zm5.622 3.415l4.879 3.252a.4.4 0 010 .666l-4.88 3.252a.4.4 0 01-.621-.332V8.747a.4.4 0 01.622-.332z"
  })));
};

var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1O({
    as: SvgComponent$1O
  }, props));
};

var _path$1G;

function ownKeys$1P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1P(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1P(Object(source), !0).forEach(function (key) { _defineProperty$1P(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1P(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var SvgComponent$1P = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm17 9H4v7h16v-7zm0-4V5H4v3h16z"
  })));
};

var SvgCardPay = function SvgCardPay(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1P({
    as: SvgComponent$1P
  }, props));
};

var _path$1H;

function ownKeys$1Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1Q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1Q(Object(source), !0).forEach(function (key) { _defineProperty$1Q(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1Q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var SvgComponent$1Q = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5V5a3 3 0 013-3h14a1 1 0 011 1v18a1 1 0 01-1 1H6.5A3.5 3.5 0 013 18.5zM19 20v-3H6.5a1.5 1.5 0 100 3H19zM5 15.337A3.485 3.485 0 016.5 15H19V4H6a1 1 0 00-1 1v10.337z"
  })));
};

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1Q({
    as: SvgComponent$1Q
  }, props));
};

var _path$1I;

function ownKeys$1R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1R(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1R(Object(source), !0).forEach(function (key) { _defineProperty$1R(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1R(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var SvgComponent$1R = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3A1.5 1.5 0 0116 4.5v5a1.5 1.5 0 11-3 0v-5A1.5 1.5 0 0114.5 3zm-10 10H6v1.5A1.5 1.5 0 114.5 13zm8.5 5h1.5a1.5 1.5 0 11-1.5 1.5V18zm1.5-5h5a1.5 1.5 0 110 3h-5a1.5 1.5 0 110-3zm5-5a1.5 1.5 0 010 3H18V9.5A1.5 1.5 0 0119.5 8zm-15 0h5a1.5 1.5 0 110 3h-5a1.5 1.5 0 110-3zm5-5A1.5 1.5 0 0111 4.5V6H9.5a1.5 1.5 0 010-3zm0 10a1.5 1.5 0 011.5 1.5v5a1.5 1.5 0 11-3 0v-5A1.5 1.5 0 019.5 13z"
  })));
};

var SvgSlack = function SvgSlack(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1R({
    as: SvgComponent$1R
  }, props));
};

var _path$1J;

function ownKeys$1S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1S(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1S(Object(source), !0).forEach(function (key) { _defineProperty$1S(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1S(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var SvgComponent$1S = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    d: "M6.455 18L2 21.5V3a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H6.455zM4 17.385L5.763 16H20V4H4v13.385zM11 12h2v2h-2v-2zm0-6h2v5h-2V6z"
  })));
};

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1S({
    as: SvgComponent$1S
  }, props));
};

var _path$1K;

function ownKeys$1T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1T(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1T(Object(source), !0).forEach(function (key) { _defineProperty$1T(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1T(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var SvgComponent$1T = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    d: "M5.463 4.433A9.961 9.961 0 0112 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 006.46 6.228l-.997-1.795zm13.074 15.134A9.961 9.961 0 0112 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0013.54 5.772l.997 1.795z"
  })));
};

var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1T({
    as: SvgComponent$1T
  }, props));
};

var _path$1L;

function ownKeys$1U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1U(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1U(Object(source), !0).forEach(function (key) { _defineProperty$1U(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1U(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var SvgComponent$1U = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    d: "M7 4V2h10v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 01-.993.993H3.993A.994.994 0 013 21.007V4.993C3 4.445 3.445 4 3.993 4H7zm0 2H5v14h14V6h-2v2H7V6zm2-2v2h6V4H9z"
  })));
};

var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1U({
    as: SvgComponent$1U
  }, props));
};

var _path$1M;

function ownKeys$1V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1V(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1V(Object(source), !0).forEach(function (key) { _defineProperty$1V(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1V(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var SvgComponent$1V = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 8H21a2 2 0 012 2v4a2 2 0 01-2 2h-1.06A8 8 0 0112 23v-2a6 6 0 006-6V9A6 6 0 106 9v7H3a2 2 0 01-2-2v-4a2 2 0 012-2h1.06a8 8 0 0115.88 0zM3 10v4h1v-4H3zm17 0v4h1v-4h-1zM7.76 15.78l1.06-1.7a5.97 5.97 0 006.36 0l1.06 1.7a7.96 7.96 0 01-8.48 0z"
  })));
};

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1V({
    as: SvgComponent$1V
  }, props));
};

var _path$1N;

function ownKeys$1W(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1W(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1W(Object(source), !0).forEach(function (key) { _defineProperty$1W(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1W(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1W(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var SvgComponent$1W = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    viewBox: "0 0 47 48",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    d: "M34.307 16.962l-.017-.007c-.01-.004-.02-.007-.027-.016a.132.132 0 01-.034-.111l.928-5.672 4.35 4.352-4.524 1.924a.1.1 0 01-.04.008h-.018a.125.125 0 01-.024-.02 2.058 2.058 0 00-.594-.458zm6.31-.346l4.65 4.652c.967.967 1.45 1.45 1.627 2.008.026.083.048.166.065.251L35.843 18.82a.675.675 0 00-.018-.008c-.044-.018-.096-.038-.096-.084 0-.045.053-.067.097-.085l.014-.006 4.776-2.02zm6.152 8.404c-.24.451-.708.92-1.5 1.712l-5.244 5.243-6.782-1.412-.037-.007c-.06-.01-.123-.02-.123-.075a2.047 2.047 0 00-.786-1.431c-.028-.028-.02-.071-.012-.11 0-.007 0-.013.002-.018l1.276-7.83.005-.027c.007-.06.018-.13.072-.13a2.076 2.076 0 001.392-.798c.01-.012.018-.025.032-.032.038-.018.084 0 .124.017l11.58 4.898zm-7.95 8.161l-8.623 8.623 1.476-9.072.002-.012a.163.163 0 01.007-.034c.012-.03.043-.041.073-.053l.015-.006a2.22 2.22 0 00.834-.62c.029-.034.063-.067.108-.073a.107.107 0 01.035 0l6.072 1.248zM28.37 43.63l-.972.972-10.745-15.53a.51.51 0 00-.012-.018c-.017-.022-.035-.045-.032-.072.001-.019.013-.036.027-.05l.012-.016c.032-.048.06-.096.09-.147l.024-.042.003-.004c.017-.029.033-.056.061-.072.026-.012.06-.007.088-.001l11.905 2.455a.197.197 0 01.091.04c.016.015.02.032.023.051a2.108 2.108 0 001.234 1.41c.034.017.02.054.003.094a.285.285 0 00-.018.054c-.15.912-1.436 8.758-1.782 10.876zm-2.03 2.029c-.716.709-1.139 1.085-1.616 1.236a2.4 2.4 0 01-1.448 0c-.559-.178-1.042-.66-2.008-1.627L10.476 34.476l2.819-4.372a.18.18 0 01.048-.056c.03-.022.073-.012.11 0a2.92 2.92 0 001.965-.1c.032-.012.065-.02.09.003a.227.227 0 01.033.038l10.8 15.671v-.001zM9.436 33.436L6.96 30.96l4.889-2.086a.102.102 0 01.04-.008c.04 0 .064.04.086.078.049.076.101.15.156.22l.015.02c.015.02.005.04-.01.06l-2.7 4.192zm-3.571-3.572l-3.132-3.132c-.533-.532-.92-.919-1.188-1.251l9.523 1.975.036.006c.059.01.123.02.123.076 0 .06-.07.087-.13.11l-.028.012-5.204 2.204zM.997 23.87a2.4 2.4 0 01.108-.594c.178-.559.66-1.041 1.628-2.008L6.74 17.26c1.845 2.678 3.695 5.353 5.55 8.024.033.043.07.091.032.127a3.33 3.33 0 00-.474.634.19.19 0 01-.06.074c-.016.01-.032.006-.05.003h-.003L.997 23.869v.001zm6.816-7.683l5.39-5.39c.506.223 2.35 1.001 3.998 1.697 1.248.528 2.386 1.008 2.743 1.164.036.015.069.03.084.065.01.022.005.05 0 .072a2.404 2.404 0 00.628 2.194c.036.036 0 .087-.031.132l-.017.025-5.472 8.476a.166.166 0 01-.052.06c-.029.018-.07.01-.103 0a2.725 2.725 0 00-.652-.088c-.197 0-.41.036-.626.076h-.001c-.024.003-.046.008-.065-.006a.252.252 0 01-.054-.062l-5.77-8.415zm6.478-6.478l6.977-6.977c.966-.966 1.45-1.45 2.008-1.626a2.4 2.4 0 011.448 0c.559.177 1.043.66 2.009 1.626l1.511 1.512-4.962 7.685a.185.185 0 01-.049.058c-.03.02-.072.012-.108 0a2.517 2.517 0 00-2.304.444c-.032.033-.08.014-.12-.004-.649-.282-5.689-2.412-6.41-2.718zm15.007-4.411L33.88 9.88l-1.104 6.837v.018a.162.162 0 01-.01.046c-.012.024-.036.029-.06.036a2.196 2.196 0 00-.681.348c-.014.014-.027.027-.048.03a.137.137 0 01-.052-.009l-6.982-2.966-.013-.006c-.044-.018-.097-.04-.097-.085a2.637 2.637 0 00-.372-1.098c-.034-.055-.07-.113-.042-.17l4.88-7.563zM24.58 15.625l6.545 2.772c.035.017.075.033.09.07a.126.126 0 010 .068c-.018.096-.035.205-.035.316v.183c0 .046-.047.065-.09.083l-.014.005C30.04 19.565 16.52 25.33 16.5 25.33c-.02 0-.042 0-.062-.02-.036-.037 0-.087.032-.133l.017-.024 5.378-8.328.01-.014c.031-.05.067-.107.125-.107l.054.008c.122.017.23.033.34.033a2.43 2.43 0 002.027-1.077.194.194 0 01.041-.048c.032-.024.08-.012.118.005zm-7.495 11.022l14.735-6.284s.022 0 .043.02c.08.08.148.135.214.185l.033.02c.03.017.06.036.062.068 0 .012 0 .019-.002.03l-1.263 7.754-.005.031c-.008.06-.016.129-.073.129a2.075 2.075 0 00-1.647 1.016l-.006.01c-.017.027-.033.054-.06.068-.026.012-.058.007-.084.001L17.28 27.271c-.012-.002-.182-.623-.196-.624z"
  })));
};

var SvgNetlify = function SvgNetlify(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1W({
    as: SvgComponent$1W
  }, props));
};

var _path$1O;

function ownKeys$1X(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1X(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1X(Object(source), !0).forEach(function (key) { _defineProperty$1X(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1X(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1X(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var SvgComponent$1X = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    viewBox: "0 0 48 48",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    d: "M24.002.014C10.652.014.014 10.652.014 24S10.652 47.99 24 47.99s23.988-10.638 23.988-23.988S37.352.014 24.002.014zM5.228 24.21l18.566 18.566c-10.222 0-18.566-8.344-18.566-18.566zm22.946 18.148L5.646 19.83C7.52 11.486 15.032 5.228 24 5.228a18.952 18.952 0 0115.228 7.72l-2.71 2.292a15.315 15.315 0 00-12.724-6.674A15.11 15.11 0 009.4 18.786l19.608 19.61c4.8-1.67 8.552-5.84 9.596-10.848h-8.136v-3.546h12.308c0 8.97-6.258 16.48-14.602 18.356z"
  })));
};

var SvgGatsby = function SvgGatsby(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1X({
    as: SvgComponent$1X
  }, props));
};

var _path$1P;

function ownKeys$1Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1Y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1Y(Object(source), !0).forEach(function (key) { _defineProperty$1Y(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1Y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var SvgComponent$1Y = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    d: "M12 3l10.4 18H1.6L12 3z"
  })));
};

var SvgVercel = function SvgVercel(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1Y({
    as: SvgComponent$1Y
  }, props));
};

var _path$1Q;

function ownKeys$1Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1Z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1Z(Object(source), !0).forEach(function (key) { _defineProperty$1Z(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1Z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var SvgComponent$1Z = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-1 2H4v14h16V5zm-2 10v2H6v-2h12z"
  })));
};

var SvgDisplay = function SvgDisplay(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1Z({
    as: SvgComponent$1Z
  }, props));
};

var _path$1R;

function ownKeys$1_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1_(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1_(Object(source), !0).forEach(function (key) { _defineProperty$1_(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1_(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var SvgComponent$1_ = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    d: "M5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
  })));
};

var SvgMoreFill = function SvgMoreFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1_({
    as: SvgComponent$1_
  }, props));
};

var _path$1S;

function ownKeys$1$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1$(Object(source), !0).forEach(function (key) { _defineProperty$1$(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1$(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var SvgComponent$1$ = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.007a1 1 0 01-.992.993H3.992A.993.993 0 013 20.007V19h18V7.3l-8 7.2-10-9V4a1 1 0 011-1h18a1 1 0 011 1v16.007zM5.434 5L13 11.81 20.566 5H5.434zM1 15h8v2H1v-2zm0-5h5v2H1v-2z"
  })));
};

var SvgMailSend = function SvgMailSend(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$1$({
    as: SvgComponent$1$
  }, props));
};

var _path$1T;

function ownKeys$20(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$20(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$20(Object(source), !0).forEach(function (key) { _defineProperty$20(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$20(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$20(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var SvgComponent$20 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
    d: "M19 3v12h3l-4 5-4-5h3V3h2zm-8 14v2H2v-2h9zm2-7v2H2v-2h11zm0-7v2H2V3h11z"
  })));
};

var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$20({
    as: SvgComponent$20
  }, props));
};

var _path$1U;

function ownKeys$21(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$21(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$21(Object(source), !0).forEach(function (key) { _defineProperty$21(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$21(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$21(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var SvgComponent$21 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
    d: "M1 12c.94-5.12 5.427-9 10.819-9 5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9C6.427 21 1.941 17.12 1 12zm10.819 5a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z"
  })));
};

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$21({
    as: SvgComponent$21
  }, props));
};

var _path$1V;

function ownKeys$22(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$22(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$22(Object(source), !0).forEach(function (key) { _defineProperty$22(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$22(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$22(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var SvgComponent$22 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
    d: "M4.339 5.541 1.212 2.415 2.627 1l19.799 19.8-1.415 1.414-3.31-3.31a10.949 10.949 0 0 1-5.882 1.703c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066h-.001Zm10.237 10.238-1.464-1.464a3 3 0 0 1-4.001-4.001L7.647 8.85a5 5 0 0 0 6.929 6.929ZM7.793 3.367c1.247-.49 2.606-.76 4.026-.76 5.392 0 9.878 3.88 10.819 9a10.946 10.946 0 0 1-2.012 4.592l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.793 3.368v-.001Z"
  })));
};

var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$22({
    as: SvgComponent$22
  }, props));
};

var _path$1W;

function ownKeys$23(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$23(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$23(Object(source), !0).forEach(function (key) { _defineProperty$23(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$23(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$23(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var SvgComponent$23 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
    d: "M14.394 11.566L8 7.303v8.526l6.394-4.263zm2.982.416L6.777 19.048A.5.5 0 016 18.632V4.5a.5.5 0 01.777-.416l10.599 7.066a.501.501 0 010 .832z"
  })));
};

var SvgPlayground = function SvgPlayground(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$23({
    as: SvgComponent$23
  }, props));
};

var _path$1X;

function ownKeys$24(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$24(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$24(Object(source), !0).forEach(function (key) { _defineProperty$24(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$24(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$24(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var SvgComponent$24 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.672 1.7l.918.918L3.836 5.37 6.59 8.125l-.918.918-2.753-2.754h-.001L2 5.373V5.37l.918-.918L5.673 1.7zm5.192 0l-.918.918L12.7 5.372 9.946 8.125l.918.918 2.753-2.753.919-.918-.918-.919L10.863 1.7zM3 19.543v-9h1.5v9h15v-15h-3v-1.5h3a1.5 1.5 0 011.5 1.5v15a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5z"
  })));
};

var SvgCodeBoxLine = function SvgCodeBoxLine(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$24({
    as: SvgComponent$24
  }, props));
};

var _path$1Y;

function ownKeys$25(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$25(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$25(Object(source), !0).forEach(function (key) { _defineProperty$25(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$25(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$25(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var SvgComponent$25 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
    d: "M15 2a4 4 0 013.464 6.001L23 8v2h-2v10a1 1 0 01-1 1H4a1 1 0 01-1-1V10H1V8l4.536.001A4 4 0 0112 3.355 3.983 3.983 0 0115 2zm-4 8H5v9h6v-9zm8 0h-6v9h6v-9zM9 4a2 2 0 00-.15 3.995L9 8h2V6a2 2 0 00-1.697-1.977l-.154-.018L9 4zm6 0a2 2 0 00-1.995 1.85L13 6v2h2a2 2 0 001.995-1.85L17 6a2 2 0 00-2-2z"
  })));
};

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$25({
    as: SvgComponent$25
  }, props));
};

var _path$1Z;

function ownKeys$26(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$26(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$26(Object(source), !0).forEach(function (key) { _defineProperty$26(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$26(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$26(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var SvgComponent$26 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4V2h2v2h6V2h2v2Zm3 6V6h-3v2h-2V6H9v2H7V6H4v4h16Zm0 2H4v8h16v-8ZM6 14h5v4H6v-4Z"
  })));
};

var SvgCalendarEvent = function SvgCalendarEvent(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$26({
    as: SvgComponent$26
  }, props));
};

var _path$1_;

function ownKeys$27(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$27(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$27(Object(source), !0).forEach(function (key) { _defineProperty$27(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$27(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$27(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var SvgComponent$27 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    d: "M17.802 14.848l-1.441-1.442 1.441-1.441a4.079 4.079 0 00-5.767-5.767l-1.441 1.441-1.442-1.441 1.442-1.442a6.116 6.116 0 018.65 8.65l-1.442 1.442zm-2.884 2.884l-1.441 1.441a6.116 6.116 0 11-8.65-8.65l1.441-1.441 1.442 1.441-1.442 1.442a4.077 4.077 0 105.767 5.767l1.442-1.442 1.441 1.442zm0-10.093l1.443 1.443-7.209 7.207-1.442-1.441 7.208-7.208z"
  })));
};

var SvgFormatLink = function SvgFormatLink(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$27({
    as: SvgComponent$27
  }, props));
};

var _path$1$;

function ownKeys$28(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$28(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$28(Object(source), !0).forEach(function (key) { _defineProperty$28(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$28(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$28(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var SvgComponent$28 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    d: "M12 12a5 5 0 11-.001 10.001A5 5 0 0112 12zm1 2h-2v1.999L9 16v2l2-.001V20h2v-2.001L15 18v-2l-2-.001V14zm7-12a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1h16zM5 4v4h14V4H5z"
  })));
};

var SvgInsertRow = function SvgInsertRow(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$28({
    as: SvgComponent$28
  }, props));
};

var _path$20;

function ownKeys$29(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$29(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$29(Object(source), !0).forEach(function (key) { _defineProperty$29(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$29(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$29(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var SvgComponent$29 = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h6zM8 5H4v14h4V5zm9 2a5 5 0 11-.001 10.001A5 5 0 0117 7zm1 2h-2v1.999L14 11v2l2-.001V15h2v-2.001L20 13v-2l-2-.001V9z"
  })));
};

var SvgInsertColumn = function SvgInsertColumn(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$29({
    as: SvgComponent$29
  }, props));
};

var _path$21;

function ownKeys$2a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2a(Object(source), !0).forEach(function (key) { _defineProperty$2a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var SvgComponent$2a = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3a1 1 0 00-1-1H4a1 1 0 00-1 1v6a1 1 0 001 1h16a1 1 0 001-1V3zM5 8V4h14v4H5zm12 9a5 5 0 11-10 0 5 5 0 0110 0zm-8-1h6v2H9v-2z"
  })));
};

var SvgRemoveRow = function SvgRemoveRow(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2a({
    as: SvgComponent$2a
  }, props));
};

var _path$22;

function ownKeys$2b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2b(Object(source), !0).forEach(function (key) { _defineProperty$2b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var SvgComponent$2b = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4a1 1 0 00-1-1H3a1 1 0 00-1 1v16a1 1 0 001 1h6a1 1 0 001-1V4zM4 5h4v14H4V5zm18 7a5 5 0 11-10 0 5 5 0 0110 0zm-8-1h6v2h-6v-2z"
  })));
};

var SvgRemoveColumn = function SvgRemoveColumn(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2b({
    as: SvgComponent$2b
  }, props));
};

var _path$23;

function ownKeys$2c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2c(Object(source), !0).forEach(function (key) { _defineProperty$2c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var SvgComponent$2c = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 1L1 2.4l2 2V20a1 1 0 001 1h15.6l1 1 1.4-1.4v-.001L2.4 1zM21 16.8V4a1 1 0 00-1-1H7.2l1.5 1.5h10.8v4h-6.8l1.5 1.5h5.3v4h-1.3l2.8 2.8zM4.5 8.5V5.9l2.6 2.6H4.5zm6.5 3.9L8.6 10H4.5v4H11v-1.6zm1.6 1.6l-.1-.1v.1h.1zm-.1 1.5h1.6l4 4h-5.6v-4zm-8 0v4H11v-4H4.5z"
  })));
};

var SvgRemoveTable = function SvgRemoveTable(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2c({
    as: SvgComponent$2c
  }, props));
};

var _path$24;

function ownKeys$2d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2d(Object(source), !0).forEach(function (key) { _defineProperty$2d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var SvgComponent$2d = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10v4H11v-4H4.5zm0 9.5v-4H11v4H4.5zm8 0v-4h7v4h-7zm7-9.5v4h-7v-4h7zM4 3a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H4z"
  })));
};

var SvgToggleHeaders = function SvgToggleHeaders(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2d({
    as: SvgComponent$2d
  }, props));
};

var _path$25;

function ownKeys$2e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2e(Object(source), !0).forEach(function (key) { _defineProperty$2e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var SvgComponent$2e = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.75 16.964-4.95-4.95 4.95-4.95-1.414-1.414-6.364 6.364 6.364 6.364 1.414-1.414Zm-5.778 0-4.95-4.95 4.95-4.95-1.414-1.414-6.364 6.364 6.364 6.364 1.414-1.414Z",
    fill: "currentColor"
  })));
};

var SvgDoubleChevronLeft = function SvgDoubleChevronLeft(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2e({
    as: SvgComponent$2e
  }, props));
};

var _path$26;

function ownKeys$2f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2f(Object(source), !0).forEach(function (key) { _defineProperty$2f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var SvgComponent$2f = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.2 7.086 4.95 4.95-4.95 4.95L6.614 18.4l6.364-6.364-6.364-6.364L5.2 7.086Zm5.778 0 4.95 4.95-4.95 4.95 1.414 1.414 6.364-6.364-6.364-6.364-1.414 1.414Z",
    fill: "currentColor"
  })));
};

var SvgDoubleChevronRight = function SvgDoubleChevronRight(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2f({
    as: SvgComponent$2f
  }, props));
};

var _path$27;

function ownKeys$2g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2g(Object(source), !0).forEach(function (key) { _defineProperty$2g(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var SvgComponent$2g = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4H3v2h18V4Zm0 14H3v2h18v-2Zm0-10H3v8h18V8ZM5 14v-4h14v4H5Z"
  })));
};

var SvgBlockEmbed = function SvgBlockEmbed(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2g({
    as: SvgComponent$2g
  }, props));
};

var _path$28;

function ownKeys$2h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2h(Object(source), !0).forEach(function (key) { _defineProperty$2h(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var SvgComponent$2h = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4H3v2h18V4ZM9.5 11H3v2h6.5v-2ZM21 18H3v2h18v-2Zm0-9H10.5v6H21V9Zm-8.167 4v-2h5.834v2h-5.834Z"
  })));
};

var SvgInlineEmbed = function SvgInlineEmbed(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2h({
    as: SvgComponent$2h
  }, props));
};

var _path$29;

function ownKeys$2i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2i(Object(source), !0).forEach(function (key) { _defineProperty$2i(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var SvgComponent$2i = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    d: "m12.778 16.172 5.364-5.364 1.414 1.414L11.778 20 4 12.222l1.414-1.414 5.364 5.364V4h2v12.172Z"
  })));
};

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2i({
    as: SvgComponent$2i
  }, props));
};

var _path$2a;

function ownKeys$2j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2j(Object(source), !0).forEach(function (key) { _defineProperty$2j(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var SvgComponent$2j = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    d: "M12.778 7.828V20h-2V7.828l-5.364 5.364L4 11.778 11.778 4l7.778 7.778-1.414 1.414-5.364-5.364Z"
  })));
};

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2j({
    as: SvgComponent$2j
  }, props));
};

var _path$2b;

function ownKeys$2k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2k(Object(source), !0).forEach(function (key) { _defineProperty$2k(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var SvgComponent$2k = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 2H4v2h16V2Zm-7.002 20V9.828l5.364 5.364 1.414-1.414L11.998 6 4.22 13.778l1.414 1.414 5.364-5.364V22h2Z"
  })));
};

var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2k({
    as: SvgComponent$2k
  }, props));
};

var _path$2c;

function ownKeys$2l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2l(Object(source), !0).forEach(function (key) { _defineProperty$2l(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var SvgComponent$2l = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 22H4v-2h16v2ZM12.998 2v12.172l5.364-5.364 1.414 1.414L11.998 18 4.22 10.222l1.414-1.414 5.364 5.364V2h2Z"
  })));
};

var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2l({
    as: SvgComponent$2l
  }, props));
};

var _path$2d;

function ownKeys$2m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2m(Object(source), !0).forEach(function (key) { _defineProperty$2m(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var SvgComponent$2m = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    d: "M17.883 18.81A9 9 0 0 1 3 12a9 9 0 0 1 9-9 9 9 0 0 1 7.371 14.166L16.5 12h2.7a7.2 7.2 0 1 0-2.214 5.195l.897 1.615Z"
  })));
};

var SvgRestart = function SvgRestart(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2m({
    as: SvgComponent$2m
  }, props));
};

var _path$2e, _path2$3;

function ownKeys$2n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2n(Object(source), !0).forEach(function (key) { _defineProperty$2n(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var SvgComponent$2n = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 4v9.757l2-2V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8.757l-2-2H5V4h14Z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.293 13.293 1.414 1.414L17 21.414l-3.707-3.707 1.414-1.414L17 18.586l5.293-5.293Z"
  })));
};

var SvgRead = function SvgRead(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2n({
    as: SvgComponent$2n
  }, props));
};

var _path$2f;

function ownKeys$2o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2o(Object(source), !0).forEach(function (key) { _defineProperty$2o(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var SvgComponent$2o = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.002 14.297c-.1 0-.19-.02-.28-.07l-9.4-4.9c-.2-.1-.32-.31-.32-.53 0-.22.12-.43.32-.53l9.4-4.9c.17-.09.38-.09.55 0l9.4 4.9c.21.1.33.31.33.53 0 .22-.12.43-.32.53l-9.4 4.9c-.09.05-.18.07-.28.07Zm-8.1-5.5 8.1 4.22 8.1-4.22-8.1-4.22-8.1 4.22Zm8.1 8.7c-.1 0-.19-.02-.28-.07l-9.4-4.9a.603.603 0 0 1-.25-.81c.15-.29.52-.41.81-.25l9.12 4.75 9.12-4.76c.29-.15.66-.04.81.25.15.29.04.66-.25.81l-9.4 4.9a.48.48 0 0 1-.28.08Zm-.28 3.13c.09.05.18.07.28.07.1 0 .19-.02.28-.08l9.4-4.9c.29-.15.4-.52.25-.81a.605.605 0 0 0-.81-.25l-9.12 4.76-9.12-4.75a.597.597 0 0 0-.81.25c-.16.29-.04.66.25.81l9.4 4.9Z"
  })));
};

var SvgStackThin = function SvgStackThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2o({
    as: SvgComponent$2o
  }, props));
};

var _path$2g;

function ownKeys$2p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2p(Object(source), !0).forEach(function (key) { _defineProperty$2p(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var SvgComponent$2p = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.107 3.073a4.633 4.633 0 0 0-6.542-.001l-.002.001-8.49 8.49a.625.625 0 0 0 .884.884l8.489-8.489a3.383 3.383 0 0 1 4.776-.002 3.383 3.383 0 0 1 .001 4.777l-8.49 8.49a.625.625 0 0 0 .884.884l8.49-8.49a4.632 4.632 0 0 0 .001-6.543h-.001Zm-2.83 3.714a.625.625 0 1 0-.884-.884l-8.49 8.49a4.633 4.633 0 0 0-.001 6.543h.001a4.633 4.633 0 0 0 6.542.002l.002-.001 8.49-8.49a.625.625 0 0 0-.884-.884l-8.489 8.489a3.382 3.382 0 0 1-4.776.002 3.383 3.383 0 0 1-.001-4.777l8.49-8.49Z"
  })));
};

var SvgAttachmentThin = function SvgAttachmentThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2p({
    as: SvgComponent$2p
  }, props));
};

var _path$2h;

function ownKeys$2q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2q(Object(source), !0).forEach(function (key) { _defineProperty$2q(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var SvgComponent$2q = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.316 2.359c.07-.571.562-.989 1.12-.989h3.11c.576 0 1.052.425 1.12.988l.001.003.26 2.05c.385.15.758.332 1.122.543.367.212.718.45 1.042.71l1.9-.804a1.126 1.126 0 0 1 1.414.467l.003.005 1.559 2.698a1.122 1.122 0 0 1-.293 1.463l-.002.002-1.634 1.249c.125.817.124 1.66-.008 2.495l1.662 1.256v.001c.45.338.587.966.295 1.464l-1.562 2.703a1.127 1.127 0 0 1-1.414.467l-1.922-.81a7.89 7.89 0 0 1-2.152 1.244l-.26 2.069-.002.012-.001.009a1.14 1.14 0 0 1-1.117.966h-3.12c-.538 0-1.062-.404-1.103-1.008l-.257-2.029a8.289 8.289 0 0 1-1.133-.547 8.349 8.349 0 0 1-1.043-.71l-1.91.804a1.126 1.126 0 0 1-1.413-.467l-.003-.005-1.558-2.698a1.123 1.123 0 0 1 .293-1.464l.002-.001 1.653-1.25a8.122 8.122 0 0 1 .008-2.494L2.312 9.495H2.31a1.136 1.136 0 0 1-.312-1.45l.007-.013 1.563-2.705a1.126 1.126 0 0 1 1.414-.467l1.922.81a7.89 7.89 0 0 1 2.153-1.244l.26-2.067ZM5.24 13.279l.01.027a.625.625 0 0 1-.215.698l-1.882 1.423 1.45 2.51 2.182-.918a.625.625 0 0 1 .744.203c.312.267.664.514 1.041.732.37.214.745.39 1.131.528.29.025.53.248.567.544l.296 2.344h2.887l.256-2.04c.049-.42.34-.774.727-.912a6.65 6.65 0 0 0 2.126-1.288.625.625 0 0 1 .66-.111l2.181.918 1.451-2.51-1.881-1.423a.625.625 0 0 1-.235-.626c.185-.893.192-1.8.03-2.666a.625.625 0 0 1 .203-.723l1.863-1.425-1.45-2.511-2.171.918a.625.625 0 0 1-.745-.203 6.97 6.97 0 0 0-1.041-.732 6.956 6.956 0 0 0-1.135-.53.626.626 0 0 1-.498-.356.624.624 0 0 1-.07-.304L13.44 2.62h-2.897l-.256 2.04c-.049.42-.34.774-.727.913A6.65 6.65 0 0 0 7.434 6.86a.625.625 0 0 1-.66.111l-2.181-.918-1.448 2.505 1.889 1.429c.192.145.284.389.234.625a6.875 6.875 0 0 0-.029 2.666Zm-2.177 2.216Zm4.31-3.5a4.625 4.625 0 1 1 9.25 0 4.625 4.625 0 0 1-9.25 0Zm4.625-3.375a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75Z"
  })));
};

var SvgSettingsThin = function SvgSettingsThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2q({
    as: SvgComponent$2q
  }, props));
};

var _path$2i;

function ownKeys$2r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2r(Object(source), !0).forEach(function (key) { _defineProperty$2r(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var SvgComponent$2r = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    d: "M18.096 3.043a1 1 0 0 1 1.414 0l1.415 1.414a1 1 0 0 1 0 1.414l-9.11 9.11a.5.5 0 0 1-.195.12l-3.182 1.06a.5.5 0 0 1-.632-.632l1.06-3.182a.5.5 0 0 1 .121-.195l9.109-9.11Zm-3.35 1.207H3.78a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V8.873l-1.2 1.2v9.477a.5.5 0 0 1-.5.5H4.48a.5.5 0 0 1-.5-.5V5.95a.5.5 0 0 1 .5-.5h9.066l1.2-1.2Zm4.365-.005a.3.3 0 0 0-.424 0l-8.839 8.839-.626 1.628a.1.1 0 0 0 .129.13l1.628-.627 8.84-8.84a.3.3 0 0 0 0-.423l-.708-.707Z"
  })));
};

var SvgFileEditThin = function SvgFileEditThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2r({
    as: SvgComponent$2r
  }, props));
};

var _path$2j;

function ownKeys$2s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2s(Object(source), !0).forEach(function (key) { _defineProperty$2s(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var SvgComponent$2s = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 3.988a1 1 0 0 0-1.54.84v14.34a1 1 0 0 0 1.54.84l11.15-7.17a1 1 0 0 0 0-1.68L7.54 3.988Zm.43 1.7a.5.5 0 0 0-.77.42v11.79c0 .4.44.63.77.42l9.17-5.89a.5.5 0 0 0 0-.84l-9.17-5.9Z"
  })));
};

var SvgPlayThin = function SvgPlayThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2s({
    as: SvgComponent$2s
  }, props));
};

var _path$2k;

function ownKeys$2t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2t(Object(source), !0).forEach(function (key) { _defineProperty$2t(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var SvgComponent$2t = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.944 6.834a.818.818 0 0 1-.07-.142 3.748 3.748 0 1 0-5.382 4.55l.53.294.547.303-3.088 5.577a.625.625 0 0 1-1.094-.606l2.482-4.483a5 5 0 1 1 7.247-5.871c.106.329-.12.658-.46.722-.287.054-.562-.1-.713-.344ZM4.83 13.438a.807.807 0 0 1-.09.13 3.75 3.75 0 1 0 6.589 2.483v-1.214l6.374-.003a.625.625 0 1 1 .001 1.25l-5.125.003a4.995 4.995 0 0 1-2.349 4.167 5 5 0 0 1-6.3-7.658c.237-.252.635-.213.855.053.187.224.186.54.045.79Zm10.702 5.593a.792.792 0 0 0-.076-.005c-.287-.006-.565.143-.674.413-.13.32.025.69.359.778a5 5 0 1 0-1.113-9.226l-2.891-4.514a.623.623 0 1 0-1.05.672l3.518 5.492.55-.296.405-.219h.002l.031-.018.092-.05a3.75 3.75 0 1 1 .894 6.98.827.827 0 0 0-.047-.007Z"
  })));
};

var SvgWebhookThin = function SvgWebhookThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2t({
    as: SvgComponent$2t
  }, props));
};

var _path$2l;

function ownKeys$2u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2u(Object(source), !0).forEach(function (key) { _defineProperty$2u(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var SvgComponent$2u = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37 12.005C1.37 6.137 6.127 1.38 11.995 1.38S22.62 6.137 22.62 12.005 17.863 22.63 11.995 22.63 1.37 17.873 1.37 12.005ZM11.995 2.63a9.375 9.375 0 1 0 0 18.75 9.375 9.375 0 0 0 0-18.75Zm.134 2.75h.006c.323 0 1.113.023 1.927.565l.003.002a3.508 3.508 0 0 1 1.387 1.89 3.61 3.61 0 0 1 0 2.205c-.199.65-.53 1.059-.865 1.475l-.065.08-.005.006c-.475.575-.943.972-1.289 1.264l-.178.152c-.375.325-.415.428-.42.502V14.006a.625.625 0 1 1-1.25 0V13.48c.027-.675.495-1.097.852-1.406l.202-.173c.343-.291.72-.61 1.117-1.09l.025-.032c.363-.452.555-.69.68-1.106l.004-.01a2.363 2.363 0 0 0-.01-1.48 2.257 2.257 0 0 0-.883-1.199 2.155 2.155 0 0 0-1.232-.354c-.222 0-.633.003-1.072.23a2.176 2.176 0 0 0-.755.641c-.486.594-.642 1.274-.694 1.65a.625.625 0 1 1-1.238-.172c.067-.482.27-1.416.957-2.26.189-.25.554-.657 1.154-.969.716-.37 1.38-.37 1.642-.37Zm-.144 12a.625.625 0 1 0 0 1.25h.02a.625.625 0 1 0 0-1.25h-.02Z"
  })));
};

var SvgQuestionThin = function SvgQuestionThin(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2u({
    as: SvgComponent$2u
  }, props));
};

var _path$2m;

function ownKeys$2v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2v(Object(source), !0).forEach(function (key) { _defineProperty$2v(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var SvgComponent$2v = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
    d: "M17.632 10.579 21.8 21h-2.042l-1.137-2.842h-3.875L13.61 21h-2.04l4.167-10.421h1.895ZM9.579 3v1.895h5.684v1.894H13.4c-.731 2.2-1.897 4.23-3.43 5.97.684.61 1.425 1.151 2.213 1.617l-.711 1.78a16.122 16.122 0 0 1-2.84-2.048 15.798 15.798 0 0 1-5.874 3.361l-.508-1.827a13.928 13.928 0 0 0 5.047-2.882A17.127 17.127 0 0 1 4.62 8.684h2.122a15.188 15.188 0 0 0 1.889 2.726 15.315 15.315 0 0 0 2.756-4.62H2V4.894h5.684V3H9.58Zm7.105 10.312-1.181 2.951h2.36l-1.179-2.95Z"
  })));
};

var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2v({
    as: SvgComponent$2v
  }, props));
};

var _path$2n;

function ownKeys$2w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2w(Object(source), !0).forEach(function (key) { _defineProperty$2w(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var SvgComponent$2w = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
    d: "m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15Z"
  })));
};

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2w({
    as: SvgComponent$2w
  }, props));
};

var _path$2o;

function ownKeys$2x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2x(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2x(Object(source), !0).forEach(function (key) { _defineProperty$2x(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var SvgComponent$2x = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2h2v3h3v2h-3v3h-2V7H8V5h3V2Zm10 13a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6ZM5 20v-4h14v4H5Z"
  })));
};

var SvgAddAbove = function SvgAddAbove(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2x({
    as: SvgComponent$2x
  }, props));
};

var _path$2p;

function ownKeys$2y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2y(Object(source), !0).forEach(function (key) { _defineProperty$2y(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var SvgComponent$2y = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3ZM5 8V4h14v4H5Zm6 6h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z"
  })));
};

var SvgAddBelow = function SvgAddBelow(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2y({
    as: SvgComponent$2y
  }, props));
};

var _path$2q;

function ownKeys$2z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2z(Object(source), !0).forEach(function (key) { _defineProperty$2z(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var SvgComponent$2z = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
    d: "M15.199 9.945a2.6 2.6 0 0 1-.79-1.551l-.403-3.083-2.73 1.486a2.6 2.6 0 0 1-1.72.273L6.5 6.5l.57 3.056a2.6 2.6 0 0 1-.273 1.72l-1.486 2.73 3.083.403a2.6 2.6 0 0 1 1.55.79l2.138 2.257 1.336-2.807a2.6 2.6 0 0 1 1.23-1.231l2.808-1.336-2.257-2.137Zm.025 5.563-2.213 4.65a.6.6 0 0 1-.977.155l-3.542-3.739a.6.6 0 0 0-.357-.182l-5.107-.668a.6.6 0 0 1-.449-.881l2.462-4.524a.6.6 0 0 0 .062-.396L4.16 4.86a.6.6 0 0 1 .7-.7l5.063.943a.6.6 0 0 0 .396-.062l4.524-2.462a.6.6 0 0 1 .881.45l.668 5.106a.6.6 0 0 0 .182.357l3.739 3.542a.599.599 0 0 1-.155.977l-4.65 2.213a.6.6 0 0 0-.284.284Zm.797 1.927 1.414-1.414 4.243 4.242-1.415 1.415-4.242-4.243Z"
  })));
};

var SvgMagic = function SvgMagic(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2z({
    as: SvgComponent$2z
  }, props));
};

var _path$2r;

function ownKeys$2A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2A(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2A(Object(source), !0).forEach(function (key) { _defineProperty$2A(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2A(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var SvgComponent$2A = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 9H4v7h16v-7Zm0-4V5H4v3h16Z"
  })));
};

var SvgBankCard = function SvgBankCard(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2A({
    as: SvgComponent$2A
  }, props));
};

var _path$2s;

function ownKeys$2B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2B(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2B(Object(source), !0).forEach(function (key) { _defineProperty$2B(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2B(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var SvgComponent$2B = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM13 13.355C13.8037 13.1128 14.4936 12.59 14.9442 11.8817C15.3947 11.1735 15.5759 10.3271 15.4547 9.49647C15.3336 8.66588 14.9181 7.90644 14.284 7.35646C13.6499 6.80647 12.8394 6.50254 12 6.5C11.1909 6.49994 10.4067 6.78015 9.78079 7.29299C9.15492 7.80583 8.72601 8.51963 8.567 9.313L10.529 9.706C10.5847 9.42743 10.7183 9.1704 10.9144 8.96482C11.1104 8.75923 11.3608 8.61354 11.6364 8.54471C11.912 8.47587 12.2015 8.48671 12.4712 8.57597C12.7409 8.66523 12.9797 8.82924 13.1598 9.04891C13.34 9.26858 13.454 9.53489 13.4887 9.81684C13.5234 10.0988 13.4773 10.3848 13.3558 10.6416C13.2343 10.8984 13.0423 11.1154 12.8023 11.2673C12.5623 11.4193 12.2841 11.5 12 11.5C11.7348 11.5 11.4804 11.6054 11.2929 11.7929C11.1054 11.9804 11 12.2348 11 12.5V14H13V13.355Z"
  })));
};

var SvgQuestionMarkFill = function SvgQuestionMarkFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2B({
    as: SvgComponent$2B
  }, props));
};

var _path$2t;

function ownKeys$2C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2C(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2C(Object(source), !0).forEach(function (key) { _defineProperty$2C(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2C(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var SvgComponent$2C = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.25H21.25V7.25H3.25V5.25ZM3.25 11.25H21.25V13.25H3.25V11.25ZM3.25 17.25H21.25V19.25H3.25V17.25Z"
  })));
};

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2C({
    as: SvgComponent$2C
  }, props));
};

var _path$2u;

function ownKeys$2D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2D(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2D(Object(source), !0).forEach(function (key) { _defineProperty$2D(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2D(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var SvgComponent$2D = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80985 5.09335C8.92367 4.00738 10.4312 3.3999 12 3.3999C13.5687 3.3999 15.0762 4.00738 16.19 5.09335C17.3044 6.17982 17.9333 7.65667 17.9333 9.1999C17.9333 12.1423 18.579 13.9894 19.1902 15.082C19.4968 15.6299 19.7982 15.9944 20.0136 16.2162C20.1215 16.3272 20.2082 16.4028 20.2637 16.4479C20.2915 16.4705 20.3115 16.4854 20.3224 16.4934L20.3313 16.4997L20.3296 16.4986L20.3284 16.4978L20.3277 16.4973C20.3291 16.4982 20.3304 16.4991 20.3317 16.5C20.5512 16.6456 20.6502 16.9175 20.5752 17.1704C20.4997 17.4252 20.2656 17.5999 20 17.5999H3.99995C3.73426 17.5999 3.50021 17.4252 3.42469 17.1704C3.34973 16.9175 3.44874 16.6456 3.66815 16.5L3.67745 16.4934C3.68841 16.4854 3.7084 16.4705 3.73618 16.4479C3.79172 16.4028 3.87843 16.3272 3.9863 16.2162C4.20173 15.9944 4.50311 15.6299 4.80966 15.082C5.42087 13.9894 6.06662 12.1423 6.06662 9.1999C6.06662 7.65667 6.69552 6.17982 7.80985 5.09335ZM18.6087 16.3999C18.4572 16.1907 18.2996 15.9478 18.143 15.6678C17.4209 14.3771 16.7333 12.3242 16.7333 9.1999C16.7333 7.98488 16.2384 6.81645 15.3523 5.95255C14.4658 5.08814 13.2601 4.5999 12 4.5999C10.7398 4.5999 9.53415 5.08814 8.64757 5.95255C7.76152 6.81645 7.26662 7.98488 7.26662 9.1999C7.26662 12.3242 6.57903 14.3771 5.85691 15.6678C5.70031 15.9478 5.54274 16.1907 5.39125 16.3999H18.6087ZM9.66659 18.501C9.9421 18.3169 10.3147 18.391 10.4988 18.6665C10.64 18.8778 10.8494 19.063 11.1143 19.1954C11.3792 19.3279 11.6849 19.3999 12 19.3999C12.315 19.3999 12.6207 19.3279 12.8856 19.1954C13.1505 19.063 13.3599 18.8778 13.5011 18.6665C13.6852 18.391 14.0578 18.3169 14.3333 18.501C14.6088 18.6851 14.6829 19.0577 14.4988 19.3333C14.2335 19.7303 13.8595 20.0501 13.4223 20.2687C12.9853 20.4872 12.4951 20.5999 12 20.5999C11.5048 20.5999 11.0146 20.4872 10.5776 20.2687C10.1404 20.0501 9.76642 19.7303 9.50108 19.3333C9.31697 19.0577 9.39107 18.6851 9.66659 18.501Z"
  })));
};

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2D({
    as: SvgComponent$2D
  }, props));
};

var _path$2v;

function ownKeys$2E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2E(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2E(Object(source), !0).forEach(function (key) { _defineProperty$2E(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2E(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var SvgComponent$2E = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
    d: "m13.62 17.025-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .96 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.198 2.29a4 4 0 1 1-.959 1.755ZM6.5 14.002a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  })));
};

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2E({
    as: SvgComponent$2E
  }, props));
};

var _path$2w;

function ownKeys$2F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2F(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2F(Object(source), !0).forEach(function (key) { _defineProperty$2F(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2F(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var SvgComponent$2F = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
    d: "m14.076 17.271-5.11-2.787a3.5 3.5 0 1 1 0-4.968l5.11-2.787a3.5 3.5 0 1 1 .958 1.755l-5.11 2.787c.102.48.102.977 0 1.458l5.11 2.787a3.5 3.5 0 1 1-.958 1.755Z",
    fill: "currentColor"
  })));
};

var SvgShareFill = function SvgShareFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2F({
    as: SvgComponent$2F
  }, props));
};

var _path$2x;

function ownKeys$2G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2G(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2G(Object(source), !0).forEach(function (key) { _defineProperty$2G(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2G(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var SvgComponent$2G = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
    d: "M13 10h5l-6 6-6-6h5V3h2v7Zm-9 9h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7Z",
    fill: "currentColor"
  })));
};

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2G({
    as: SvgComponent$2G
  }, props));
};

var _path$2y;

function ownKeys$2H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2H(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2H(Object(source), !0).forEach(function (key) { _defineProperty$2H(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2H(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var SvgComponent$2H = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.602 13.76 1.412 1.412 8.466-8.466 1.414 1.414-9.88 9.88-6.364-6.364 1.414-1.414 2.125 2.125 1.413 1.412v.001Zm.002-2.828 4.952-4.953 1.41 1.41-4.952 4.953-1.41-1.41Zm-2.827 5.655L7.364 18 1 11.636l1.414-1.414 1.413 1.413-.001.001 4.951 4.951Z"
  })));
};

var SvgDoubleCheck = function SvgDoubleCheck(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2H({
    as: SvgComponent$2H
  }, props));
};

var _path$2z;

function ownKeys$2I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2I(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2I(Object(source), !0).forEach(function (key) { _defineProperty$2I(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2I(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var SvgComponent$2I = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
    d: "M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1H7ZM5.002 8 5 20h10V8H5.002ZM9 6h8v10h2V4H9v2Zm-2 5h6v2H7v-2Zm0 4h6v2H7v-2Z"
  })));
};

var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2I({
    as: SvgComponent$2I
  }, props));
};

var _path$2A;

function ownKeys$2J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2J(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2J(Object(source), !0).forEach(function (key) { _defineProperty$2J(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2J(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var SvgComponent$2J = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.438l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154V13Z"
  })));
};

var SvgSendFill = function SvgSendFill(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2J({
    as: SvgComponent$2J
  }, props));
};

var _path$2B;

function ownKeys$2K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2K(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2K(Object(source), !0).forEach(function (key) { _defineProperty$2K(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2K(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var SvgComponent$2K = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    viewBox: "0 0 24 24",
    fill: "none",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9467 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.586L21.121 15.464L22.536 16.879L20.414 19L22.536 21.121L21.121 22.536L19 20.414L16.879 22.536L15.464 21.121L17.586 19L15.464 16.879L16.879 15.464L19 17.586Z",
    fill: "#64709C"
  })));
};

var SvgRemoveUser = function SvgRemoveUser(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2K({
    as: SvgComponent$2K
  }, props));
};

var _path$2C;

function ownKeys$2L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2L(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2L(Object(source), !0).forEach(function (key) { _defineProperty$2L(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2L(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var SvgComponent$2L = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
    d: "M5.828 7.95L8.364 10.486L6.95 11.9L2 6.95L6.95 2L8.364 3.414L5.828 5.95H13C15.1217 5.95 17.1566 6.79286 18.6569 8.29315C20.1571 9.79344 21 11.8283 21 13.95C21 16.0717 20.1571 18.1066 18.6569 19.6069C17.1566 21.1071 15.1217 21.95 13 21.95H4V19.95H13C14.5913 19.95 16.1174 19.3179 17.2426 18.1926C18.3679 17.0674 19 15.5413 19 13.95C19 12.3587 18.3679 10.8326 17.2426 9.70736C16.1174 8.58214 14.5913 7.95 13 7.95H5.828Z",
    fill: "currentColor"
  })));
};

var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2L({
    as: SvgComponent$2L
  }, props));
};

var _path$2D;

function ownKeys$2M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2M(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2M(Object(source), !0).forEach(function (key) { _defineProperty$2M(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2M(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var SvgComponent$2M = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    fill: "none",
    viewBox: "0 0 24 24",
    "data-icon": "hygraph-icon",
    "aria-hidden": "true",
    focusable: "false",
    tabIndex: "-1"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 2.375 2.375 3.6l1.75 1.75V19c0 .483.392.874.875.874h13.65l.874.875 1.226-1.224L3.6 2.375ZM19.875 16.2V5A.875.875 0 0 0 19 4.123H7.8l1.313 1.313h9.45v3.5h-5.95l1.312 1.312h4.637v3.5h-1.137l2.45 2.45ZM5.437 8.937V6.662l2.275 2.275H5.438Zm5.688 3.413-2.1-2.1H5.436v3.5h5.688v-1.4Zm1.4 1.4-1.4-1.4v1.4h1.4Zm-1.4 1.312h2.712l3.5 3.5h-6.212v-3.5Zm-5.688 0v3.5h5.688v-3.5H5.437Z"
  })));
};

var SvgNoFields = function SvgNoFields(props) {
  return /*#__PURE__*/React.createElement(StyledSvg, _objectSpread$2M({
    as: SvgComponent$2M
  }, props));
};

export { SvgAdd as Add, SvgAddAbove as AddAbove, SvgAddBelow as AddBelow, SvgAddCircleFill as AddCircleFill, SvgAddUser as AddUser, SvgAdminFill as AdminFill, SvgAppLocalization as AppLocalization, SvgAppStages as AppStages, SvgAppsThin as AppsThin, SvgArrowBack as ArrowBack, SvgArrowBottom as ArrowBottom, SvgArrowDown as ArrowDown, SvgArrowLeft as ArrowLeft, SvgArrowRight as ArrowRight, SvgArrowRightUp as ArrowRightUp, SvgArrowTop as ArrowTop, SvgArrowUp as ArrowUp, SvgArrowUpDown as ArrowUpDown, SvgAttachmentThin as AttachmentThin, SvgBankCard as BankCard, SvgBasicComponent as BasicComponent, SvgBell as Bell, SvgBilling as Billing, SvgBlockEmbed as BlockEmbed, SvgBranch as Branch, SvgBrush as Brush, SvgCalendarEvent as CalendarEvent, SvgCardPay as CardPay, SvgCaretDownFill as CaretDownFill, SvgCaretLeftFill as CaretLeftFill, SvgCaretRightFill as CaretRightFill, SvgCaretUpFill as CaretUpFill, SvgChat as Chat, SvgChatNew as ChatNew, SvgCheck as Check, SvgChevronDown as ChevronDown, SvgChevronLeft as ChevronLeft, SvgChevronRight as ChevronRight, SvgChevronUp as ChevronUp, SvgClipboard as Clipboard, SvgClose as Close, SvgCloudUpload as CloudUpload, SvgCode as Code, SvgCodeBoxFill as CodeBoxFill, SvgCodeBoxLine as CodeBoxLine, SvgCopy as Copy, SvgDeleteFilled as DeleteFilled, SvgDisplay as Display, SvgDocument as Document, SvgDoubleCheck as DoubleCheck, SvgDoubleChevronLeft as DoubleChevronLeft, SvgDoubleChevronRight as DoubleChevronRight, SvgDownload as Download, SvgDragHandle as DragHandle, SvgDuplicate as Duplicate, SvgEdit as Edit, SvgEditBoxFill as EditBoxFill, SvgEmpty as Empty, SvgError as Error, SvgError404 as Error404, SvgExtension as Extension, SvgExternalLink as ExternalLink, SvgEye as Eye, SvgEyeOff as EyeOff, SvgFeedback as Feedback, SvgFieldAsset as FieldAsset, SvgFieldCheckbox as FieldCheckbox, SvgFieldColor as FieldColor, SvgFieldDate as FieldDate, SvgFieldDateTime as FieldDateTime, SvgFieldDropdown as FieldDropdown, SvgFieldFloat as FieldFloat, SvgFieldId as FieldId, SvgFieldInteger as FieldInteger, SvgFieldJson as FieldJson, SvgFieldLocation as FieldLocation, SvgFieldMarkdown as FieldMarkdown, SvgFieldMultiLine as FieldMultiLine, SvgFieldRelation as FieldRelation, SvgFieldRelationManyToMany as FieldRelationManyToMany, SvgFieldRelationManyToOne as FieldRelationManyToOne, SvgFieldRelationOneToMany as FieldRelationOneToMany, SvgFieldRelationOneToOne as FieldRelationOneToOne, SvgFieldRichText as FieldRichText, SvgFieldSingleLine as FieldSingleLine, SvgFileCopyFill as FileCopyFill, SvgFileEditThin as FileEditThin, SvgFilter as Filter, SvgFilterFunnel as FilterFunnel, SvgFlash as Flash, SvgFlashOff as FlashOff, SvgFlashlightThin as FlashlightThin, SvgFormatBold as FormatBold, SvgFormatItalic as FormatItalic, SvgFormatLink as FormatLink, SvgFormatListBulleted as FormatListBulleted, SvgFormatListNumbered as FormatListNumbered, SvgFormatQuote as FormatQuote, SvgFormatUnderlined as FormatUnderline, SvgFullscreen as Fullscreen, SvgFullscreenExit as FullscreenExit, SvgGatsby as Gatsby, SvgGift as Gift, SvgGraphql as GraphQL, SvgHistory as History, SvgImage as Image, SvgInfo as Info, SvgInlineEmbed as InlineEmbed, SvgInsertColumn as InsertColumn, SvgInsertRow as InsertRow, SvgList as List, SvgLoader as Loader, SvgLocale as Locale, SvgLock as Lock, SvgMagic as Magic, SvgMailSend as MailSend, SvgManyToMany as ManyToMany, SvgManyToOne as ManyToOne, SvgMenu as Menu, SvgModularComponent as ModularComponent, SvgMoreFill as MoreFill, SvgNetlify as Netlify, SvgNewFolder as NewFolder, SvgNoFields as NoFields, SvgOneToMany as OneToMany, SvgOneToOne as OneToOne, SvgOrderAsc as OrderAsc, SvgOrderDesc as OrderDesc, SvgPencil as Pencil, SvgPencilFill as PencilFill, SvgPlayThin as PlayThin, SvgPlayground as Playground, SvgPublish as Publish, SvgQuestionMarkFill as QuestionFill, SvgQuestionThin as QuestionThin, SvgRest as REST, SvgRead as Read, SvgReference as Reference, SvgRefresh as Refresh, SvgRemoveColumn as RemoveColumn, SvgRemoveRow as RemoveRow, SvgRemoveTable as RemoveTable, SvgRemoveUser as RemoveUser, SvgRestart as Restart, SvgSearch as Search, SvgSendFill as SendFill, SvgSettings as Settings, SvgSettingsThin as SettingsThin, SvgShare as Share, SvgShareFill as ShareFill, SvgSlack as Slack, SvgSlug as Slug, SvgSort as Sort, SvgStackThin as StackThin, SvgStatusActive as StatusActive, SvgStatusCompleted as StatusCompleted, SvgStatusDisabled as StatusDisabled, SvgStatusInitial as StatusInitial, SvgSuccess as Success, SvgSupport as Support, SvgSync as Sync, SvgTable as Table, SvgTime as Time, SvgToggleHeaders as ToggleHeaders, SvgTranslate as Translate, SvgUnreference as UnReference, SvgUndo as Undo, SvgUnlock as Unlock, SvgUnpublish as Unpublish, SvgUser as User, SvgUserReceivedFill as UserReceivedFill, SvgVercel as Vercel, SvgVideo as Video, SvgWarning as Warning, SvgWeb as Web, SvgWebhook as Webhook, SvgWebhookThin as WebhookThin };
//# sourceMappingURL=index.esm.js.map
